
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("67UrT", function(module, exports) {
$parcel$export(module.exports, "UniformEntryPage", function () { return $567142e6bd5e85f1$export$f0d4a992b207ed41; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iSeHD = parcelRequire("iSeHD");

var $4EfnG = parcelRequire("4EfnG");

var $7WM7y = parcelRequire("7WM7y");
parcelRequire("1RvSu");
var $ipRTK = parcelRequire("ipRTK");

var $ea4mV = parcelRequire("ea4mV");

var $doAVE = parcelRequire("doAVE");

var $2ve7k = parcelRequire("2ve7k");
const $567142e6bd5e85f1$export$f0d4a992b207ed41 = ({ composition: composition, compositionMetrics: compositionMetrics, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const [dxpMigrationExposureFired, fireDxpMigrationExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).dxpMigrationSoftwarePage);
    const [jiraFflExposureFired, fireJiraFflExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4666JiraFfl);
    (0, $1oC0p.useEffect)(()=>{
        if (!jiraFflExposureFired) fireJiraFflExposure();
    }, [
        jiraFflExposureFired,
        fireJiraFflExposure
    ]);
    const [dxpMigrationJsmAnchorJourneyExposureFired, fireDxpMigrationJsmAnchorJourneyExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).dxpMigrationJsmAnchorJourney);
    const isDxpMigrationJsmAnchorJourney = (0, $ea4mV.getExperiment)((0, $ea4mV.experiments).dxpMigrationJsmAnchorJourney);
    const isLoggedOut = (0, $doAVE.useLoggedOut)();
    const isJSM = (0, $doAVE.useSpecifiedPathnames)([
        "/software/jira/service-management"
    ]);
    const location = (0, $2ve7k.useLocation)();
    (0, $1oC0p.useEffect)(()=>{
        if (!dxpMigrationJsmAnchorJourneyExposureFired && isDxpMigrationJsmAnchorJourney.type === "enrolled" && isDxpMigrationJsmAnchorJourney.value === true && isLoggedOut && isJSM && location.search.includes("cmsVariant") && (typeof window !== "undefined" ? [
            `paid-lp-jsm-itsm`,
            `paid-lp-jsm-features`,
            `paid-lp-jsm-service-desk`,
            `paid-lp-jsm-ticketing`
        ].includes(window.cmsPageVariant || "") : [
            `paid-lp-jsm-itsm`,
            `paid-lp-jsm-features`,
            `paid-lp-jsm-service-desk`,
            `paid-lp-jsm-ticketing`
        ].some((variant)=>location.search.includes(variant)))) fireDxpMigrationJsmAnchorJourneyExposure();
    }, [
        dxpMigrationJsmAnchorJourneyExposureFired,
        fireDxpMigrationJsmAnchorJourneyExposure,
        isDxpMigrationJsmAnchorJourney,
        isJSM,
        isLoggedOut,
        location.search
    ]);
    const { compositionFetchStart: compositionFetchStart, compositionCacheStatus: compositionCacheStatus, ssrEndTime: ssrEndTime } = compositionMetrics || {};
    const sendPageRenderAnalyticsEvent = (0, $1oC0p.useCallback)((pageRenderTime, ssrEndTime, compositionFetchStart, fcp)=>{
        if (pageRenderTime && analyticsClient) analyticsClient.sendUIEvent({
            action: "pageRender",
            actionSubject: "uniformPage",
            source: window.location.pathname,
            attributes: {
                pageRenderTime: pageRenderTime,
                compositionFetchStart: compositionFetchStart,
                ssrEndTime: ssrEndTime,
                compositionCacheStatus: compositionCacheStatus,
                fcp: fcp,
                isUniformPlayground: isUniformPlayground || false
            }
        });
    }, [
        analyticsClient,
        compositionCacheStatus,
        isUniformPlayground
    ]);
    (0, $1oC0p.useEffect)(()=>{
        // @ts-ignore
        const measureFirstContentfulPaint = ()=>{
            try {
                // First, check if FCP is already available
                const paintEntries = performance.getEntriesByType("paint");
                const firstContentfulPaint = paintEntries.find((entry)=>entry.name === "first-contentful-paint");
                if (firstContentfulPaint && ssrEndTime && compositionFetchStart) {
                    const fcp = firstContentfulPaint.startTime;
                    // Calculate page render time
                    const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                    if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                    return firstContentfulPaint.startTime;
                }
                // If FCP isn't available yet, observe for it
                const observer = new PerformanceObserver((list)=>{
                    const entries = list.getEntries();
                    const fcpEntry = entries.find((entry)=>entry.name === "first-contentful-paint");
                    if (fcpEntry && compositionFetchStart && ssrEndTime) {
                        const fcp = fcpEntry.startTime;
                        // Calculate page render time
                        const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                        if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                        observer.disconnect();
                    }
                });
                observer.observe({
                    entryTypes: [
                        "paint"
                    ]
                });
                // Cleanup observer after 10 seconds to prevent memory leaks
                setTimeout(()=>{
                    observer.disconnect();
                }, 10000);
                return undefined;
            } catch (error) {
                console.warn("Error measuring Page Render Time:", error);
                return undefined;
            }
        };
        measureFirstContentfulPaint();
    }, [
        compositionFetchStart,
        compositionMetrics,
        sendPageRenderAnalyticsEvent,
        ssrEndTime
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!dxpMigrationExposureFired) fireDxpMigrationExposure();
    }, [
        dxpMigrationExposureFired,
        fireDxpMigrationExposure
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "uniform-entry-page-root",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ipRTK.UniformEntryPageTemplate), {
                    composition: composition,
                    isUniformPlayground: isUniformPlayground,
                    isAllowPostMessage: isAllowPostMessage
                })
            })
        })
    });
};

});
parcelRegister("7WM7y", function(module, exports) {
$parcel$export(module.exports, "FourOhFourPageTemplate", function () { return $b3e0454f7f1f85f3$export$580adf4c24c28053; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $8LaTa = parcelRequire("8LaTa");

var $l2QYX = parcelRequire("l2QYX");

var $1ka2O = parcelRequire("1ka2O");

var $4d61Q = parcelRequire("4d61Q");
const $b3e0454f7f1f85f3$export$580adf4c24c28053 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "404-page",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1ka2O.LocationProvider), {
            location: typeof window !== "undefined" ? window.location : {
                pathname: "/",
                href: "/"
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.default), {
                        isShowTryNowLink: true,
                        tryNowLinkCtaButtonColor: "light_grey",
                        productKey: "404"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4d61Q.MainSection), {})
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
            ]
        })
    });
};

});

parcelRegister("1RvSu", function(module, exports) {
$parcel$export(module.exports, "UniformEntryPageTemplate", function () { return (parcelRequire("ipRTK")).UniformEntryPageTemplate; });

var $ipRTK = parcelRequire("ipRTK");

});
parcelRegister("ipRTK", function(module, exports) {
$parcel$export(module.exports, "UniformEntryPageTemplate", function () { return $9b881e462c85fa95$export$8328465fb6b6a7d2; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $dNSrU = parcelRequire("dNSrU");

var $4EfnG = parcelRequire("4EfnG");

var $7WM7y = parcelRequire("7WM7y");

var $g7CEg = parcelRequire("g7CEg");

var $9rnwe = parcelRequire("9rnwe");
const $9b881e462c85fa95$export$8328465fb6b6a7d2 = ({ composition: composition, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const { uniformContext: uniformContext } = (0, $9rnwe.useWAEContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dNSrU.UniformContext), {
            context: uniformContext,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g7CEg.UniformWrapper), {
                composition: composition,
                isUniformPlayground: isUniformPlayground,
                isAllowPostMessage: isAllowPostMessage
            })
        })
    });
};

});



parcelRegister("3NQOU", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $b6785f1d81c92020$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $gLm0b = parcelRequire("gLm0b");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $hp3ar = parcelRequire("hp3ar");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-4ebbb62b15";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
const $b6785f1d81c92020$var$BASE_URL = "https://www.atlassian.com";
const $b6785f1d81c92020$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $b6785f1d81c92020$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    const route = path !== "" ? "/" + path : "";
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $hp3ar.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const page = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "canonical",
                    href: `${$b6785f1d81c92020$var$BASE_URL}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "alternate",
                    href: `${$b6785f1d81c92020$var$BASE_URL}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $b6785f1d81c92020$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${$b6785f1d81c92020$var$BASE_URL}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    compositionRegenerationMetadata: window._uniformRegenerationMetadata,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $konOj.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $konOj.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("gHIMV", function(module, exports) {

var $24uwp = parcelRequire("24uwp");

var $7RbbL = parcelRequire("7RbbL");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $c2936778f0bf11fd$var$capitalize(string) {
    return $7RbbL($24uwp(string).toLowerCase());
}
module.exports = $c2936778f0bf11fd$var$capitalize;

});
parcelRegister("7RbbL", function(module, exports) {

var $iBcGo = parcelRequire("iBcGo");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $5b86297e1fc1db25$var$upperFirst = $iBcGo('toUpperCase');
module.exports = $5b86297e1fc1db25$var$upperFirst;

});
parcelRegister("iBcGo", function(module, exports) {

var $ehULU = parcelRequire("ehULU");

var $ePM67 = parcelRequire("ePM67");

var $1GITV = parcelRequire("1GITV");

var $24uwp = parcelRequire("24uwp");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $d8a585375440fb5a$var$createCaseFirst(methodName) {
    return function(string) {
        string = $24uwp(string);
        var strSymbols = $ePM67(string) ? $1GITV(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $ehULU(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $d8a585375440fb5a$var$createCaseFirst;

});
parcelRegister("ehULU", function(module, exports) {

var $ezuzU = parcelRequire("ezuzU");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $a66eb0e6cce6b4e5$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $ezuzU(array, start, end);
}
module.exports = $a66eb0e6cce6b4e5$var$castSlice;

});
parcelRegister("ezuzU", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $a9bc0dc53628b88a$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $a9bc0dc53628b88a$var$baseSlice;

});


parcelRegister("ePM67", function(module, exports) {
/** Used to compose unicode character classes. */ var $accb234eacd9a37f$var$rsAstralRange = '\\ud800-\\udfff', $accb234eacd9a37f$var$rsComboMarksRange = '\\u0300-\\u036f', $accb234eacd9a37f$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $accb234eacd9a37f$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $accb234eacd9a37f$var$rsComboRange = $accb234eacd9a37f$var$rsComboMarksRange + $accb234eacd9a37f$var$reComboHalfMarksRange + $accb234eacd9a37f$var$rsComboSymbolsRange, $accb234eacd9a37f$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $accb234eacd9a37f$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $accb234eacd9a37f$var$reHasUnicode = RegExp('[' + $accb234eacd9a37f$var$rsZWJ + $accb234eacd9a37f$var$rsAstralRange + $accb234eacd9a37f$var$rsComboRange + $accb234eacd9a37f$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $accb234eacd9a37f$var$hasUnicode(string) {
    return $accb234eacd9a37f$var$reHasUnicode.test(string);
}
module.exports = $accb234eacd9a37f$var$hasUnicode;

});

parcelRegister("1GITV", function(module, exports) {

var $3VH6A = parcelRequire("3VH6A");

var $ePM67 = parcelRequire("ePM67");

var $aYfG6 = parcelRequire("aYfG6");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $13ac8b161df780fb$var$stringToArray(string) {
    return $ePM67(string) ? $aYfG6(string) : $3VH6A(string);
}
module.exports = $13ac8b161df780fb$var$stringToArray;

});
parcelRegister("3VH6A", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $2dc821c7632c8518$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $2dc821c7632c8518$var$asciiToArray;

});

parcelRegister("aYfG6", function(module, exports) {
/** Used to compose unicode character classes. */ var $7fcbab4f0bbb188c$var$rsAstralRange = '\\ud800-\\udfff', $7fcbab4f0bbb188c$var$rsComboMarksRange = '\\u0300-\\u036f', $7fcbab4f0bbb188c$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $7fcbab4f0bbb188c$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $7fcbab4f0bbb188c$var$rsComboRange = $7fcbab4f0bbb188c$var$rsComboMarksRange + $7fcbab4f0bbb188c$var$reComboHalfMarksRange + $7fcbab4f0bbb188c$var$rsComboSymbolsRange, $7fcbab4f0bbb188c$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $7fcbab4f0bbb188c$var$rsAstral = '[' + $7fcbab4f0bbb188c$var$rsAstralRange + ']', $7fcbab4f0bbb188c$var$rsCombo = '[' + $7fcbab4f0bbb188c$var$rsComboRange + ']', $7fcbab4f0bbb188c$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $7fcbab4f0bbb188c$var$rsModifier = '(?:' + $7fcbab4f0bbb188c$var$rsCombo + '|' + $7fcbab4f0bbb188c$var$rsFitz + ')', $7fcbab4f0bbb188c$var$rsNonAstral = '[^' + $7fcbab4f0bbb188c$var$rsAstralRange + ']', $7fcbab4f0bbb188c$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $7fcbab4f0bbb188c$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $7fcbab4f0bbb188c$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $7fcbab4f0bbb188c$var$reOptMod = $7fcbab4f0bbb188c$var$rsModifier + '?', $7fcbab4f0bbb188c$var$rsOptVar = '[' + $7fcbab4f0bbb188c$var$rsVarRange + ']?', $7fcbab4f0bbb188c$var$rsOptJoin = '(?:' + $7fcbab4f0bbb188c$var$rsZWJ + '(?:' + [
    $7fcbab4f0bbb188c$var$rsNonAstral,
    $7fcbab4f0bbb188c$var$rsRegional,
    $7fcbab4f0bbb188c$var$rsSurrPair
].join('|') + ')' + $7fcbab4f0bbb188c$var$rsOptVar + $7fcbab4f0bbb188c$var$reOptMod + ')*', $7fcbab4f0bbb188c$var$rsSeq = $7fcbab4f0bbb188c$var$rsOptVar + $7fcbab4f0bbb188c$var$reOptMod + $7fcbab4f0bbb188c$var$rsOptJoin, $7fcbab4f0bbb188c$var$rsSymbol = '(?:' + [
    $7fcbab4f0bbb188c$var$rsNonAstral + $7fcbab4f0bbb188c$var$rsCombo + '?',
    $7fcbab4f0bbb188c$var$rsCombo,
    $7fcbab4f0bbb188c$var$rsRegional,
    $7fcbab4f0bbb188c$var$rsSurrPair,
    $7fcbab4f0bbb188c$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $7fcbab4f0bbb188c$var$reUnicode = RegExp($7fcbab4f0bbb188c$var$rsFitz + '(?=' + $7fcbab4f0bbb188c$var$rsFitz + ')|' + $7fcbab4f0bbb188c$var$rsSymbol + $7fcbab4f0bbb188c$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7fcbab4f0bbb188c$var$unicodeToArray(string) {
    return string.match($7fcbab4f0bbb188c$var$reUnicode) || [];
}
module.exports = $7fcbab4f0bbb188c$var$unicodeToArray;

});





parcelRegister("jmley", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("gfjAv")).default; });

var $gfjAv = parcelRequire("gfjAv");

});

parcelRegister("LlYs2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a02f6f2bebc5924b5c7f92f48f61953>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08e56f7bc5f7a423$var$_react = $08e56f7bc5f7a423$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $08e56f7bc5f7a423$var$_baseNew = $08e56f7bc5f7a423$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $08e56f7bc5f7a423$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $08e56f7bc5f7a423$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $08e56f7bc5f7a423$var$_react.default.createElement($08e56f7bc5f7a423$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$08e56f7bc5f7a423$var$InformationCircleIcon.displayName = 'InformationCircleIcon';
var $08e56f7bc5f7a423$var$_default = module.exports.default = $08e56f7bc5f7a423$var$InformationCircleIcon;

});

parcelRegister("46Ma8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e570c2c471e9f2c44e5e57e4d5245eb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2fdd15086956a812$var$_react = $2fdd15086956a812$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2fdd15086956a812$var$_baseNew = $2fdd15086956a812$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $2fdd15086956a812$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2fdd15086956a812$var$AddIcon = (props)=>/*#__PURE__*/ $2fdd15086956a812$var$_react.default.createElement($2fdd15086956a812$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z" clip-rule="evenodd"/>`
    }, props));
$2fdd15086956a812$var$AddIcon.displayName = 'AddIcon';
var $2fdd15086956a812$var$_default = module.exports.default = $2fdd15086956a812$var$AddIcon;

});

parcelRegister("5oMeU", function(module, exports) {

var $hLLeA = parcelRequire("hLLeA");

var $119FI = parcelRequire("119FI");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $3ee49cf968a053d8$var$baseGet(object, path) {
    path = $hLLeA(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$119FI(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $3ee49cf968a053d8$var$baseGet;

});

parcelRegister("4EAwS", function(module, exports) {

var $5oMeU = parcelRequire("5oMeU");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $36373bd43f9f4b21$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $5oMeU(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $36373bd43f9f4b21$var$get;

});

parcelRegister("5RBBI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $444f1300adfdb621$var$_react = $444f1300adfdb621$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $444f1300adfdb621$var$_baseNew = $444f1300adfdb621$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $444f1300adfdb621$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $444f1300adfdb621$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $444f1300adfdb621$var$_react.default.createElement($444f1300adfdb621$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$444f1300adfdb621$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $444f1300adfdb621$var$_default = module.exports.default = $444f1300adfdb621$var$ChevronDownIcon;

});

parcelRegister("9tc44", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3359cfcb124b9edec9402a579fa9711>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e502e4b67b18fd0$var$_react = $6e502e4b67b18fd0$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6e502e4b67b18fd0$var$_baseNew = $6e502e4b67b18fd0$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $6e502e4b67b18fd0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e502e4b67b18fd0$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $6e502e4b67b18fd0$var$_react.default.createElement($6e502e4b67b18fd0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$6e502e4b67b18fd0$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $6e502e4b67b18fd0$var$_default = module.exports.default = $6e502e4b67b18fd0$var$CheckboxCheckedIcon;

});

parcelRegister("3GRvb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::481d1ea8ad85e9d7b0bddff8ba9b16d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2afecbb2c786369d$var$_react = $2afecbb2c786369d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2afecbb2c786369d$var$_baseNew = $2afecbb2c786369d$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $2afecbb2c786369d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListChecklist".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: Checklist, 'Requirement' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2afecbb2c786369d$var$ListChecklistIcon = (props)=>/*#__PURE__*/ $2afecbb2c786369d$var$_react.default.createElement($2afecbb2c786369d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.59 9.97-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07-1.37-2.12 1.26-.81.81 1.25 2.33-2.95zm0-7.5-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07L.01 4.04l1.26-.81.81 1.25 2.33-2.95zM16 11v1.5H7V11zm0-7.5V5H7V3.5z"/>`
    }, props));
$2afecbb2c786369d$var$ListChecklistIcon.displayName = 'ListChecklistIcon';
var $2afecbb2c786369d$var$_default = module.exports.default = $2afecbb2c786369d$var$ListChecklistIcon;

});

parcelRegister("gvZeq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bbccaea74398c387e69395dfeae5f34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c05f09ee49282e55$var$_react = $c05f09ee49282e55$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c05f09ee49282e55$var$_baseNew = $c05f09ee49282e55$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $c05f09ee49282e55$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c05f09ee49282e55$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $c05f09ee49282e55$var$_react.default.createElement($c05f09ee49282e55$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$c05f09ee49282e55$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $c05f09ee49282e55$var$_default = module.exports.default = $c05f09ee49282e55$var$PeopleGroupIcon;

});

parcelRegister("26k9M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfc058bc597636775f186a66702ef9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $187bc709663ecc73$var$_react = $187bc709663ecc73$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $187bc709663ecc73$var$_baseNew = $187bc709663ecc73$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $187bc709663ecc73$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $187bc709663ecc73$var$BoardIcon = (props)=>/*#__PURE__*/ $187bc709663ecc73$var$_react.default.createElement($187bc709663ecc73$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$187bc709663ecc73$var$BoardIcon.displayName = 'BoardIcon';
var $187bc709663ecc73$var$_default = module.exports.default = $187bc709663ecc73$var$BoardIcon;

});

parcelRegister("4szpS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33f53fe53f7c5942$var$_react = $33f53fe53f7c5942$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $33f53fe53f7c5942$var$_baseNew = $33f53fe53f7c5942$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $33f53fe53f7c5942$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33f53fe53f7c5942$var$BacklogIcon = (props)=>/*#__PURE__*/ $33f53fe53f7c5942$var$_react.default.createElement($33f53fe53f7c5942$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$33f53fe53f7c5942$var$BacklogIcon.displayName = 'BacklogIcon';
var $33f53fe53f7c5942$var$_default = module.exports.default = $33f53fe53f7c5942$var$BacklogIcon;

});

parcelRegister("lfTOg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7964a51710834b2$var$_react = $f7964a51710834b2$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f7964a51710834b2$var$_baseNew = $f7964a51710834b2$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f7964a51710834b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7964a51710834b2$var$CalendarIcon = (props)=>/*#__PURE__*/ $f7964a51710834b2$var$_react.default.createElement($f7964a51710834b2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$f7964a51710834b2$var$CalendarIcon.displayName = 'CalendarIcon';
var $f7964a51710834b2$var$_default = module.exports.default = $f7964a51710834b2$var$CalendarIcon;

});

parcelRegister("PQhz5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f64abe706416b0877b5dd221be64e7d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09bd51b6223980e7$var$_react = $09bd51b6223980e7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $09bd51b6223980e7$var$_baseNew = $09bd51b6223980e7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $09bd51b6223980e7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09bd51b6223980e7$var$PageIcon = (props)=>/*#__PURE__*/ $09bd51b6223980e7$var$_react.default.createElement($09bd51b6223980e7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$09bd51b6223980e7$var$PageIcon.displayName = 'PageIcon';
var $09bd51b6223980e7$var$_default = module.exports.default = $09bd51b6223980e7$var$PageIcon;

});

parcelRegister("fLF1J", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7de7c2be3f7c9d9cc79e629bb0768f3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b7ab11e61c51605b$var$_react = $b7ab11e61c51605b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $b7ab11e61c51605b$var$_baseNew = $b7ab11e61c51605b$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $b7ab11e61c51605b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Timeline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for timelines in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b7ab11e61c51605b$var$TimelineIcon = (props)=>/*#__PURE__*/ $b7ab11e61c51605b$var$_react.default.createElement($b7ab11e61c51605b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11 2.5H1V1h10zm4 4.167H5v-1.5h10zm-4 4.167H1v-1.5h10zM15 15H5v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$b7ab11e61c51605b$var$TimelineIcon.displayName = 'TimelineIcon';
var $b7ab11e61c51605b$var$_default = module.exports.default = $b7ab11e61c51605b$var$TimelineIcon;

});

parcelRegister("l8kCZ", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return (parcelRequire("bTseT")).IntercomProvider; });
parcelRequire("bTseT");
parcelRequire("25OgP");

});
parcelRegister("bTseT", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return $d787a990cb9c57de$export$5091c5023e5c7eba; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $6GqRO = parcelRequire("6GqRO");

var $PE2DD = parcelRequire("PE2DD");

var $cIXzQ = parcelRequire("cIXzQ");
const $d787a990cb9c57de$var$isWindowExist = typeof window !== "undefined";
const $d787a990cb9c57de$export$e578ca56db818a8e = /*#__PURE__*/ $1oC0p.createContext(undefined);
const $d787a990cb9c57de$export$5091c5023e5c7eba = ({ appId: appId, triggerBoot: triggerBoot = false, children: children })=>{
    const isBooted = $1oC0p.useRef(false);
    const isInit = $1oC0p.useRef(false);
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const initIntercomInstance = $1oC0p.useCallback(()=>{
        if (!isInit.current) {
            (0, $cIXzQ.default)(appId);
            isInit.current = true;
        }
    }, [
        appId
    ]);
    // Ensure DOM is fully ready and stable before Intercom initialization
    const ensureDOMReady = $1oC0p.useCallback(()=>{
        return new Promise((resolve)=>{
            if (document.readyState === "complete") // DOM is ready, but add buffer time for iframe stability
            setTimeout(resolve, 500);
            else {
                // Wait for DOM completion, then add buffer time
                const cleanup = ()=>{
                    document.removeEventListener("DOMContentLoaded", handleLoad);
                    window.removeEventListener("load", handleLoad);
                };
                const handleLoad = ()=>{
                    cleanup();
                    clearTimeout(safetyTimeout);
                    setTimeout(resolve, 500);
                };
                // Add event listeners for DOM ready
                document.addEventListener("DOMContentLoaded", handleLoad);
                window.addEventListener("load", handleLoad);
                // Safety timeout: resolve after 10 seconds even if events don't fire
                const safetyTimeout = setTimeout(()=>{
                    cleanup();
                    console.error("Intercom: DOM ready timeout reached, proceeding anyway");
                    resolve();
                }, 10000);
            }
        });
    }, []);
    const boot = $1oC0p.useCallback(async ()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isInit.current && !isBooted.current) {
            var _window_intercomSettings;
            const intercomSettings = (_window_intercomSettings = window.intercomSettings) !== null && _window_intercomSettings !== void 0 ? _window_intercomSettings : {
                app_id: appId
            };
            try {
                var _window_Intercom, _window, _window_Intercom1, _window1;
                // Wait for DOM to be fully ready and stable
                await ensureDOMReady();
                (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "boot", (0, $6ogO3._)({
                    alignment: "right",
                    horizontal_padding: 20,
                    vertical_padding: 20,
                    custom_launcher_selector: "#intercomLauncher"
                }, intercomSettings));
                (_window_Intercom1 = (_window1 = window).Intercom) === null || _window_Intercom1 === void 0 ? void 0 : _window_Intercom1.call(_window1, "trackEvent", "widget-loaded");
            } catch (error) {
                console.warn("Intercom boot failed:", error);
            } finally{
                isBooted.current = true; // Set value as true to enable functionality of show/hide methods
            }
        }
    }, [
        appId,
        ensureDOMReady
    ]);
    const shutdown = $1oC0p.useCallback(()=>{
        if (!isBooted.current) return;
        if ($d787a990cb9c57de$var$isWindowExist) {
            var _window_Intercom, _window;
            (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "shutdown");
            delete window.intercomSettings;
            isBooted.current = false;
        }
    }, []);
    const show = $1oC0p.useCallback(()=>{
        var _window_Intercom, _window;
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "show");
    }, []);
    const hide = $1oC0p.useCallback(()=>{
        var _window_Intercom, _window;
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "hide");
    }, []);
    $1oC0p.useEffect(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && triggerBoot) (async function() {
            const intercomSettingsObj = {
                app_id: appId
            };
            const anonId = (0, $6GqRO.default).get("ajs_anonymous_id") || "";
            if (anonId) intercomSettingsObj["anonymousId"] = anonId;
            const getwayApiMeGetResponse = await stargateClient.me({}).catch(()=>null);
            if (getwayApiMeGetResponse) {
                intercomSettingsObj["name"] = getwayApiMeGetResponse.name;
                intercomSettingsObj["email"] = getwayApiMeGetResponse.email;
            }
            if ($d787a990cb9c57de$var$isWindowExist) window.intercomSettings = intercomSettingsObj;
            if (!isInit.current) initIntercomInstance();
            if (isInit.current && !isBooted.current) boot();
        })();
        // clean up code
        return ()=>{
            if (isInit.current) shutdown();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerBoot,
        stargateClient
    ]);
    const providerValue = $1oC0p.useMemo(()=>{
        return {
            initIntercomInstance: initIntercomInstance,
            boot: boot,
            shutdown: shutdown,
            show: show,
            hide: hide
        };
    }, [
        initIntercomInstance,
        boot,
        shutdown,
        show,
        hide
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d787a990cb9c57de$export$e578ca56db818a8e.Provider, {
        value: providerValue,
        children: children
    });
};
const $d787a990cb9c57de$export$28418e623d2470bc = ()=>{
    const context = $1oC0p.useContext($d787a990cb9c57de$export$e578ca56db818a8e);
    if (context === undefined) throw new Error("This hook must be used within IntercomProvider");
    return context;
};

});
parcelRegister("cIXzQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $578d2b441e63143c$export$2e2bcd8739ae039; });
function $578d2b441e63143c$var$isIELikeWindow(w) {
    return Object.prototype.hasOwnProperty.call(w, "attachEvent");
}
// Function per instruction here: https://developers.intercom.com/installing-intercom/web/installation/
const $578d2b441e63143c$var$initializeIntercomInstance = (appId)=>{
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
    } else {
        const d = document;
        const i = function() {
            i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
            i.q.push(args);
        };
        w.Intercom = i;
        const l = function() {
            var _x_parentNode;
            const s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://widget.intercom.io/widget/" + appId;
            const x = d.getElementsByTagName("script")[0];
            x === null || x === void 0 ? void 0 : (_x_parentNode = x.parentNode) === null || _x_parentNode === void 0 ? void 0 : _x_parentNode.insertBefore(s, x);
        };
        if (document.readyState === "complete") l();
        else if ($578d2b441e63143c$var$isIELikeWindow(w)) w.attachEvent("onload", l);
        else w.addEventListener("load", l, false);
    }
};
var $578d2b441e63143c$export$2e2bcd8739ae039 = $578d2b441e63143c$var$initializeIntercomInstance;

});


parcelRegister("25OgP", function(module, exports) {
// Intercom Types & Interface ===========================================================
// all the Interface stuff from: https://developers.intercom.com/installing-intercom/web/attributes-objects/

});


parcelRegister("lOlsU", function(module, exports) {
$parcel$export(module.exports, "useFirePricingPlanCtaEvent", function () { return $94595cb38e128ae6$export$7f90eaa475fc1c9f; });

var $fuLgT = parcelRequire("fuLgT");

var $eY3N6 = parcelRequire("eY3N6");
function $94595cb38e128ae6$export$7f90eaa475fc1c9f(props) {
    const { edition: edition, productKey: productKey, containerId: containerId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const createPayload = ()=>({
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            containerId: containerId,
            actionSubjectId: "pricingPlanCta",
            attributes: {
                migrationExperimentCta: true,
                pricingEventId: (0, $fuLgT.default)(),
                productKey: productKey,
                edition: edition
            }
        });
    return ()=>createAnalyticsEvent(createPayload()).fire();
}

});

parcelRegister("1RK9J", function(module, exports) {
$parcel$export(module.exports, "getFreePriceCalc", function () { return $9f9b50f36097439e$export$cb6f0dbb8c9b28d2; });
$parcel$export(module.exports, "usePriceFinderRequests", function () { return $9f9b50f36097439e$export$e1ef037d62746bfa; });
$parcel$export(module.exports, "usePricing", function () { return $9f9b50f36097439e$export$2bd1dff4b72a4894; });

var $1oC0p = parcelRequire("1oC0p");

var $hrGO1 = parcelRequire("hrGO1");

var $ieLA0 = parcelRequire("ieLA0");

var $69Lp1 = parcelRequire("69Lp1");

var $8dsKS = parcelRequire("8dsKS");
const $9f9b50f36097439e$export$cb6f0dbb8c9b28d2 = (currencyISOCode)=>{
    const zeroPrice = (0, $ieLA0.getFormattedPrice)(currencyISOCode, 0);
    return {
        totalPrice: 0,
        avgPerUnitPrice: 0,
        avgPerUnitPriceWithDiscount: 0,
        formattedTotalPrice: zeroPrice,
        formattedAvgPerUnitPrice: zeroPrice,
        formattedAvgPerUnitPriceWithDiscount: zeroPrice,
        formattedTotalPriceWithDiscount: zeroPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: 0,
                unitsAvailableInTier: 0,
                unitLimitLower: 0,
                unitLimitUpper: 0,
                totalPriceForTier: 0,
                avgPerUnitPriceForTier: 0
            }
        ],
        formattedBreakdown: [
            {
                formattedUnitsInTier: "0",
                formattedUnitsAvailableInTier: "0",
                formattedUnitLimitLower: "0",
                formattedUnitLimitUpper: "0",
                formattedTotalPriceForTier: zeroPrice,
                formattedAvgPerUnitPriceForTier: zeroPrice
            }
        ]
    };
};
const $9f9b50f36097439e$export$e1ef037d62746bfa = (productKey, productPlans, unitMinEnterprise, unitCount, billingCycle)=>{
    return (0, $1oC0p.useMemo)(()=>{
        const getNumUnits = (planName, signupUnitLimit)=>{
            let adjNumUnits = 0;
            // following scenarios do not have pricing and should send a zero unit count,
            // the zero pricing will not be displayed and is needed only to retain the
            // correct array order of the pricing requests/responses
            // Free plan has no pricing
            const isFree = planName === (0, $hrGO1.SpecialPlanNames).FREE;
            // Enterprise plans do not have monthly pricing
            const isMonthlyEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && billingCycle === "MONTHLY";
            // Enterprise plans have a minimum unit count
            const isUnmetUnitCountEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && unitCount < unitMinEnterprise;
            const isOverSignupUnitLimit = unitCount > signupUnitLimit;
            if (![
                isFree,
                isMonthlyEnterprise,
                isUnmetUnitCountEnterprise,
                isOverSignupUnitLimit
            ].includes(true)) adjNumUnits = unitCount;
            // keep unit count to general maximum limit
            return Math.min(adjNumUnits, signupUnitLimit);
        };
        const planPriceReqs = productPlans.map(({ offeringSku: offeringSku, planName: planName, signupLimit: signupLimit })=>({
                ccpOfferingSKU: offeringSku,
                hamsProductKey: productKey + (planName === (0, $hrGO1.SpecialPlanNames).STANDARD ? "" : `.${planName.toLowerCase()}`),
                numUnits: getNumUnits(planName, signupLimit || (0, $hrGO1.DefaultPlanLimits).UNIT_LIMIT),
                period: billingCycle
            }));
        return planPriceReqs;
    }, [
        productPlans,
        productKey,
        billingCycle,
        unitCount,
        unitMinEnterprise
    ]);
};
const $9f9b50f36097439e$export$2bd1dff4b72a4894 = (ccpPricingData, hamsPricingData, getPriceRequests, currencyISOCode, localeISOCode)=>{
    const priceCalculations = [];
    for (const { ccpOfferingSKU: ccpOfferingSKU, hamsProductKey: hamsProductKey, numUnits: numUnits, period: period } of getPriceRequests)if (numUnits === 0) priceCalculations.push($9f9b50f36097439e$export$cb6f0dbb8c9b28d2(currencyISOCode));
    else {
        const pricingTiers = (0, $69Lp1.extractPricingTiersFromEntry)(ccpPricingData, hamsPricingData, period, currencyISOCode, ccpOfferingSKU, hamsProductKey);
        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            priceCalculations.push($9f9b50f36097439e$export$cb6f0dbb8c9b28d2(currencyISOCode));
        } else priceCalculations.push((0, $8dsKS.calculatePrice)(numUnits, pricingTiers, currencyISOCode, period, localeISOCode));
    }
    return priceCalculations;
};

});
parcelRegister("ieLA0", function(module, exports) {
$parcel$export(module.exports, "getFormattedPrice", function () { return $db8d9502e3c15040$export$1b80ff309ec5fcb1; });
$parcel$export(module.exports, "getTwoDigitFormattedPrice", function () { return $db8d9502e3c15040$export$716b461c5fe22c57; });
$parcel$export(module.exports, "getFormattedUnitAmount", function () { return $db8d9502e3c15040$export$4f6f7f43804883a5; });
const $db8d9502e3c15040$export$93b318a4d10f1db1 = (value)=>{
    if (value !== null && value !== undefined && !Number.isNaN(value)) return Number.isInteger(+value) ? 0 : 2;
    else return 0;
};
const $db8d9502e3c15040$var$fmtCurrencyValue = (currencyISOCode, value, useTwoDigits)=>{
    const isJPY = currencyISOCode === "JPY";
    const adjVal = isJPY ? Math.ceil(value || 0) : value;
    return new Intl.NumberFormat(isJPY ? "ja-JP" : "en-US", {
        style: "currency",
        currency: currencyISOCode,
        // Note: JPY does not use decimals
        minimumFractionDigits: useTwoDigits && !isJPY ? 2 : $db8d9502e3c15040$export$93b318a4d10f1db1(adjVal),
        maximumFractionDigits: useTwoDigits && !isJPY ? 2 : $db8d9502e3c15040$export$93b318a4d10f1db1(adjVal)
    }).format(adjVal || 0);
};
const $db8d9502e3c15040$export$1b80ff309ec5fcb1 = (currencyISOCode, value)=>$db8d9502e3c15040$var$fmtCurrencyValue(currencyISOCode, value, false);
const $db8d9502e3c15040$export$716b461c5fe22c57 = (currencyISOCode, value)=>$db8d9502e3c15040$var$fmtCurrencyValue(currencyISOCode, value, true);
const $db8d9502e3c15040$export$4f6f7f43804883a5 = (localeISOCode, value)=>new Intl.NumberFormat(localeISOCode).format(value || 0);

});

parcelRegister("69Lp1", function(module, exports) {
$parcel$export(module.exports, "extractPricingTiersFromEntry", function () { return $eeff08f2d55148ea$export$99b3bd15b49bca3d; });

var $6AKYt = parcelRequire("6AKYt");
const $eeff08f2d55148ea$export$99b3bd15b49bca3d = (ccpOfferingsBySKU, hamsPricingPlansByKey, period, currencyISOCode, ccpOfferingSKU, hamsProductKey, getCcpTiers)=>{
    let pricingPlans;
    let pricingTiers;
    if (ccpOfferingSKU) {
        const offering = ccpOfferingsBySKU[ccpOfferingSKU];
        pricingPlans = offering === null || offering === void 0 ? void 0 : offering.defaultPricingPlans;
        if (!pricingPlans) {
            console.log(`Offering empty of pricing plan data for: ${ccpOfferingSKU}`);
            return undefined;
        }
        const convertedTiers = (0, $6AKYt.convertCCPPricingPlansToHAMS)(pricingPlans, currencyISOCode, getCcpTiers);
        if (period === "MONTHLY" && convertedTiers.monthly) pricingTiers = convertedTiers.monthly.slice();
        else if (period === "ANNUAL" && convertedTiers.annual) pricingTiers = convertedTiers.annual.slice();
        else {
            console.log(`Found neither monthly or annual pricing tiers for CCP Offering SKU: ${ccpOfferingSKU}`);
            return undefined;
        }
    } else {
        if (hamsProductKey === undefined) {
            console.log(`HAMS product key was undefined for price request!`);
            return undefined;
        }
        pricingPlans = hamsPricingPlansByKey[hamsProductKey];
        if (pricingPlans === undefined) {
            console.log(`No ${period} pricing plans found for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
        if (period === "MONTHLY" && pricingPlans.monthly) pricingTiers = pricingPlans.monthly.slice();
        else if (period === "ANNUAL" && pricingPlans.annual) pricingTiers = pricingPlans.annual.slice();
        else {
            console.log(`Found neither monthly or annual (period is ${period}) pricing tiers for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
    }
    return pricingTiers;
};

});
parcelRegister("6AKYt", function(module, exports) {
$parcel$export(module.exports, "convertCCPPricingPlansToHAMS", function () { return $ba494f9c4080e515$export$1fb00d50ed2ce89c; });

var $hrGO1 = parcelRequire("hrGO1");
// CCP Amounts are stored in cents - Note: JPY needs no conversion
const $ba494f9c4080e515$var$formatCentsToDollars = (value, currency)=>{
    if (currency === "USD" && value) return value / 100;
    return value;
};
const $ba494f9c4080e515$var$convertCCPTiersToHAMS = (ccpTiers, chargeElement, currency)=>ccpTiers.map((ccpTier)=>{
        let pricingStrategy = (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT;
        let unitPrice = ccpTier.unitAmount;
        if (ccpTier.flatAmount) {
            pricingStrategy = (0, $hrGO1.PricingStrategy).FIXED_COST;
            unitPrice = ccpTier.flatAmount;
        }
        return {
            starter: false,
            pricingStrategy: pricingStrategy,
            unitDescription: chargeElement,
            unitLimitLower: ccpTier.floor,
            unitLimitUpper: ccpTier.ceiling,
            prices: [
                {
                    currency: currency,
                    unitPrice: $ba494f9c4080e515$var$formatCentsToDollars(unitPrice, currency)
                }
            ]
        };
    });
const $ba494f9c4080e515$export$1fb00d50ed2ce89c = (pricingPlans, currencyISOCode, getCcpTiers)=>{
    const [monthlyCCP, annualCCP] = [
        "MONTH",
        "YEAR"
    ].map((primaryCycle)=>// Per CCP Team: We need to filter by COMMERCIAL, DEFAULT_PRICING
        pricingPlans.find((pricingPlan)=>pricingPlan.primaryCycle_interval === primaryCycle && pricingPlan.type === "COMMERCIAL" && pricingPlan.activatedWithReason === "DEFAULT_PRICING" && // We filter by currencyISOCode as we need both USD & JPY Pricing for Pricing Pages
            // If needed, can filter by USD only which we will pass in directly in those components
            pricingPlan.currency === currencyISOCode));
    const [monthly, annual] = [
        monthlyCCP,
        annualCCP
    ].map((ccpContent)=>{
        if (!ccpContent) return undefined;
        const ccpTiers = getCcpTiers ? getCcpTiers(ccpContent) : ccpContent.items[0];
        const { tiers: tiers, chargeElement: chargeElement } = ccpTiers;
        return $ba494f9c4080e515$var$convertCCPTiersToHAMS(tiers, chargeElement, ccpContent.currency);
    });
    return {
        monthly: monthly,
        annual: annual
    };
};

});


parcelRegister("8dsKS", function(module, exports) {
$parcel$export(module.exports, "calculatePrice", function () { return $9c8fafac440a889f$export$8f857d3e1dbdf9cf; });

var $hrGO1 = parcelRequire("hrGO1");

var $ieLA0 = parcelRequire("ieLA0");

var $cuq2S = parcelRequire("cuq2S");

var $fmcUV = parcelRequire("fmcUV");
const $9c8fafac440a889f$var$getTierIdxForNumUnits = (numUnits, tiers)=>tiers.findIndex(({ unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper })=>numUnits >= (unitLimitLower || 0) && numUnits <= (unitLimitUpper || Math.pow(10, 1000)));
function $9c8fafac440a889f$export$8f857d3e1dbdf9cf(numUnits, tiers, currencyISOCode, period, localeISOCode = "en-US") {
    if (!Number.isInteger(numUnits) || numUnits < 1) throw new Error(`Number of units must be a positive non-zero integer, got ${numUnits}.`);
    if (!tiers || tiers.length === 0) throw new Error(`Price tiers must not be null, undefined or an empty array, got ${tiers}.`);
    tiers.sort((a, b)=>{
        var _a_unitLimitLower, _b_unitLimitLower;
        return ((_a_unitLimitLower = a.unitLimitLower) !== null && _a_unitLimitLower !== void 0 ? _a_unitLimitLower : 0) - ((_b_unitLimitLower = b.unitLimitLower) !== null && _b_unitLimitLower !== void 0 ? _b_unitLimitLower : 0);
    });
    let matchingTierIdx = $9c8fafac440a889f$var$getTierIdxForNumUnits(numUnits, tiers);
    const matchingTier = tiers[matchingTierIdx];
    const finalTier = tiers[tiers.length - 1];
    let adjustedNumberOfUnits = numUnits;
    let calcFunc;
    if (matchingTier !== undefined) {
        const tierPricingStrategy = matchingTier.pricingStrategy;
        calcFunc = period === "MONTHLY" || tierPricingStrategy === (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT ? (0, $fmcUV.default) : (0, $cuq2S.default);
    } else if (finalTier && finalTier.pricingStrategy === (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT) calcFunc = (0, $fmcUV.default);
    else {
        /*
     * When a user input is greater than the max tier limit
     * we will reset the number of users to max tier limit
     * of that product and perform price calculations.
     * */ adjustedNumberOfUnits = (finalTier === null || finalTier === void 0 ? void 0 : finalTier.unitLimitUpper) || 0;
        matchingTierIdx = $9c8fafac440a889f$var$getTierIdxForNumUnits(adjustedNumberOfUnits, tiers);
        calcFunc = (0, $cuq2S.default);
    }
    const fmtUnit = (amount)=>(0, $ieLA0.getFormattedUnitAmount)(localeISOCode, amount);
    const fmtPrice = (price)=>(0, $ieLA0.getFormattedPrice)(currencyISOCode, price);
    const { totalPrice: totalPrice, avgPerUnitPrice: avgPerUnitPrice, hasFlatRateFirstTier: hasFlatRateFirstTier, breakdown: breakdown } = calcFunc(adjustedNumberOfUnits, matchingTierIdx, tiers, currencyISOCode);
    const avgPerUnitPriceWithDiscount = (0, $cuq2S.calculateDiscountedPrice)(0.75, avgPerUnitPrice);
    const totalPriceWithDiscount = (0, $cuq2S.calculateDiscountedPrice)(0.75, totalPrice);
    return {
        totalPrice: totalPrice,
        avgPerUnitPriceWithDiscount: avgPerUnitPriceWithDiscount,
        formattedTotalPrice: fmtPrice(totalPrice),
        formattedAvgPerUnitPriceWithDiscount: fmtPrice(avgPerUnitPriceWithDiscount),
        formattedTotalPriceWithDiscount: fmtPrice(totalPriceWithDiscount),
        avgPerUnitPrice: avgPerUnitPrice,
        formattedAvgPerUnitPrice: fmtPrice(avgPerUnitPrice),
        breakdown: breakdown,
        hasFlatRateFirstTier: hasFlatRateFirstTier,
        formattedBreakdown: breakdown.map(({ unitsInTier: unitsInTier, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, unitsAvailableInTier: unitsAvailableInTier, totalPriceForTier: totalPriceForTier, avgPerUnitPriceForTier: avgPerUnitPriceForTier })=>({
                formattedUnitsInTier: fmtUnit(unitsInTier),
                formattedUnitsAvailableInTier: fmtUnit(unitsAvailableInTier),
                formattedUnitLimitLower: fmtUnit(unitLimitLower),
                formattedUnitLimitUpper: fmtUnit(unitLimitUpper),
                formattedTotalPriceForTier: (0, $ieLA0.getTwoDigitFormattedPrice)(currencyISOCode, totalPriceForTier),
                formattedAvgPerUnitPriceForTier: (0, $ieLA0.getTwoDigitFormattedPrice)(currencyISOCode, avgPerUnitPriceForTier)
            }))
    };
}

});
parcelRegister("cuq2S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $20e5665ddc9d914c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "calculateDiscountedPrice", function () { return $20e5665ddc9d914c$export$3a875854e1248ca4; });

var $8q2jX = parcelRequire("8q2jX");
function $20e5665ddc9d914c$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    const matchingTier = tiers[matchingTierIdx];
    if (!matchingTier) throw new Error(`Matching price tier not found for ${numUnits}.`);
    const { prices: prices, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = matchingTier;
    const totalPrice = (0, $8q2jX.getLocalUnitPrice)(currencyISOCode, prices.slice());
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: numUnits,
                unitsAvailableInTier: (unitLimitUpper || 0) - numUnits,
                unitLimitLower: unitLimitLower || 1,
                unitLimitUpper: unitLimitUpper || 0,
                totalPriceForTier: totalPrice,
                avgPerUnitPriceForTier: totalPrice / numUnits
            }
        ]
    };
}
const $20e5665ddc9d914c$export$3a875854e1248ca4 = (discountRate, price)=>price * (1 - discountRate);

});
parcelRegister("8q2jX", function(module, exports) {
$parcel$export(module.exports, "getLocalUnitPrice", function () { return $032de19fb775a510$export$e4a3f0ac75d6f09; });
const $032de19fb775a510$export$e4a3f0ac75d6f09 = (currencyISOCode, prices)=>{
    var _prices_find;
    return ((_prices_find = prices.find(({ currency: currency })=>currency === currencyISOCode)) === null || _prices_find === void 0 ? void 0 : _prices_find.unitPrice) || 0;
};

});


parcelRegister("fmcUV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e064390e0d1f8ae6$export$2e2bcd8739ae039; });

var $hrGO1 = parcelRequire("hrGO1");

var $8q2jX = parcelRequire("8q2jX");
function $e064390e0d1f8ae6$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    var _tiers_;
    let totalPrice = 0;
    let price = 0;
    const breakdown = [];
    const getUnitPrice = (prices)=>(0, $8q2jX.getLocalUnitPrice)(currencyISOCode, prices);
    // if no matching tier then default to highest (last) tier
    if (matchingTierIdx === -1) matchingTierIdx = tiers.length - 1;
    let idx = 0;
    for (const tier of tiers){
        const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = tier;
        const adjUnitLimitLower = Math.max((unitLimitLower || 0) - 1, 0);
        // the upper unit limit can't be undefined so we can just set it to
        // one million units as an upper bound
        const adjUnitLimitUpper = unitLimitUpper || 1000000;
        const unitsInTier = idx === matchingTierIdx ? numUnits - adjUnitLimitLower : adjUnitLimitUpper - adjUnitLimitLower;
        if (tier.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST) price = getUnitPrice(tier.prices.slice());
        else {
            const finalTier = tiers[Math.min(idx, tiers.length - 1)];
            price = getUnitPrice(finalTier.prices.slice());
        }
        const totalPriceForTier = tier.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST ? price : unitsInTier * price;
        totalPrice += totalPriceForTier;
        breakdown.push({
            unitsInTier: unitsInTier,
            unitsAvailableInTier: adjUnitLimitUpper - unitsInTier,
            unitLimitLower: adjUnitLimitLower || 1,
            unitLimitUpper: adjUnitLimitUpper,
            totalPriceForTier: totalPriceForTier,
            avgPerUnitPriceForTier: price
        });
        if (++idx > matchingTierIdx) break;
    }
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: ((_tiers_ = tiers[0]) === null || _tiers_ === void 0 ? void 0 : _tiers_.pricingStrategy) === (0, $hrGO1.PricingStrategy).FIXED_COST,
        breakdown: breakdown
    };
}

});



parcelRegister("8EEDU", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return (parcelRequire("hBYvx")).Video; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("hBYvx")).Video; });

var $hBYvx = parcelRequire("hBYvx");

});
parcelRegister("hBYvx", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return $5a5d9245727e1968$export$ae01dedf5c052bb; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $5a5d9245727e1968$var$videoStyle = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== "none" ? {
        aspectRatio: ratio,
        objectFit: "cover"
    } : {};
    return (0, $6ogO3._)({
        maxWidth: "100%"
    }, aspectRatioCSS);
};
const $5a5d9245727e1968$export$ae01dedf5c052bb = ({ videoLink: videoLink, videoType: videoType, videoPreviewImage: videoPreviewImage, loop: loop = true, muted: muted = true, aspectRatio: aspectRatio, alternativeSources: alternativeSources, className: className, fallbackText: fallbackText, onEnded: onEnded, children: children })=>{
    const videoRef = (0, $1oC0p.useRef)(null);
    // reload video player if video source prop changes dynamically
    (0, $1oC0p.useEffect)(()=>{
        var _videoRef_current;
        (_videoRef_current = videoRef.current) === null || _videoRef_current === void 0 ? void 0 : _videoRef_current.load();
    }, [
        videoLink
    ]);
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $5a5d9245727e1968$var$videoStyle(aspectRatio),
        loop: loop,
        ref: videoRef,
        onEnded: onEnded,
        children: [
            fallbackText,
            /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                src: videoLink,
                type: `video/${videoType ? videoType : "mp4"}`
            }),
            alternativeSources ? alternativeSources.map((source, index)=>{
                return /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                    src: source.videoLink,
                    type: `video/${source.videoType ? source.videoType : "mp4"}`
                }, index);
            }) : null,
            children
        ]
    }));
};

});


parcelRegister("aSr2F", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5437a6fa40a6a5e2291c258b3bd34ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7eb3ec80aea1436f$var$_react = $7eb3ec80aea1436f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7eb3ec80aea1436f$var$_baseNew = $7eb3ec80aea1436f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $7eb3ec80aea1436f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7eb3ec80aea1436f$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $7eb3ec80aea1436f$var$_react.default.createElement($7eb3ec80aea1436f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$7eb3ec80aea1436f$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $7eb3ec80aea1436f$var$_default = module.exports.default = $7eb3ec80aea1436f$var$CheckMarkIcon;

});

parcelRegister("fz5gy", function(module, exports) {
$parcel$export(module.exports, "GuardLogo", function () { return $b54e359ca5207dcd$export$a4a891d202775deb; });
/* eslint-disable max-len */ 
var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $2TpZZ = parcelRequire("2TpZZ");

var $cTVn3 = parcelRequire("cTVn3");
var $b54e359ca5207dcd$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2TpZZ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 114 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $b54e359ca5207dcd$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $b54e359ca5207dcd$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("5S2vX", function(module, exports) {
$parcel$export(module.exports, "useParentScrollTracking", function () { return $d703c208f3e9c795$export$164ddb76b909974a; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return $d703c208f3e9c795$export$248f1dfc9396e7e4; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("j6FQw");
var $je135 = parcelRequire("je135");
const $d703c208f3e9c795$var$ScrollTrackingContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    pageId: "wac-web",
    scrollTrackingEnabled: true
});
const $d703c208f3e9c795$export$164ddb76b909974a = ()=>{
    return (0, $1oC0p.useContext)($d703c208f3e9c795$var$ScrollTrackingContext);
};
const $d703c208f3e9c795$export$248f1dfc9396e7e4 = (props)=>{
    const parentContext = $d703c208f3e9c795$export$164ddb76b909974a();
    const arrayChildren = (0, $1oC0p.Children).toArray(props.children);
    const definedName = (child)=>{
        if (/*#__PURE__*/ (0, $1oC0p.isValidElement)(child) && child.type) {
            // Use a type assertion to tell TypeScript that the type has a displayName
            const namedComponent = child.type;
            return namedComponent.displayName;
        } else return undefined;
    };
    // Determine tracking of parent undefined means true
    const parentTrackScrolling = parentContext.scrollTrackingEnabled === undefined ? true : parentContext.scrollTrackingEnabled;
    // Parent should take precedence if parent tracking is disabled
    const trackScrolling = parentTrackScrolling && (props.scrollTrackingEnabled === undefined ? true : props.scrollTrackingEnabled);
    var _props_pageId;
    const pageId = (_props_pageId = props.pageId) !== null && _props_pageId !== void 0 ? _props_pageId : parentContext.pageId;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d703c208f3e9c795$var$ScrollTrackingContext.Provider, {
        value: {
            pageId: pageId,
            scrollTrackingEnabled: trackScrolling
        },
        children: (0, $1oC0p.Children).map(arrayChildren, (child, index)=>{
            const name = definedName(child);
            return name ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $je135.ScrollTracking), {
                index: `${index}/${arrayChildren.length}`,
                section: name,
                as: props.as,
                children: child
            }, index) : child;
        })
    });
};

});
parcelRegister("j6FQw", function(module, exports) {
$parcel$export(module.exports, "ScrollTracking", function () { return (parcelRequire("je135")).ScrollTracking; });
$parcel$export(module.exports, "useScrollTracking", function () { return (parcelRequire("je135")).useScrollTracking; });
$parcel$export(module.exports, "withScrollTracking", function () { return (parcelRequire("je135")).withScrollTracking; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return (parcelRequire("5S2vX")).ParentScrollTracking; });
parcelRequire("je135");
parcelRequire("5S2vX");

});
parcelRegister("je135", function(module, exports) {
$parcel$export(module.exports, "useScrollTracking", function () { return $0fbf1a9bc3d0315b$export$17700584f55fbc70; });
$parcel$export(module.exports, "ScrollTracking", function () { return $0fbf1a9bc3d0315b$export$1725757b7947b890; });
$parcel$export(module.exports, "withScrollTracking", function () { return $0fbf1a9bc3d0315b$export$391633ede08dabb1; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jKShK = parcelRequire("jKShK");

var $eY3N6 = parcelRequire("eY3N6");

var $5S2vX = parcelRequire("5S2vX");

var $iSeHD = parcelRequire("iSeHD");
const $0fbf1a9bc3d0315b$export$17700584f55fbc70 = (section, props = {})=>{
    const { index: index, observerOptions: observerOptions, dwellTimeEnabled: dwellTimeEnabled, additionalAttributes: additionalAttributes } = props;
    const hasFunctionBeenCalled = (0, $1oC0p.useRef)(false);
    const scrollPercentage = (0, $1oC0p.useRef)(0);
    const { pageId: pageId, scrollTrackingEnabled: scrollTrackingEnabled } = (0, $5S2vX.useParentScrollTracking)();
    const { ref: ref, inView: inView, entry: entry } = (0, $jKShK.useInView)((0, $dPABA._)((0, $6ogO3._)({
        threshold: 0.5,
        triggerOnce: true
    }, observerOptions), {
        skip: (observerOptions === null || observerOptions === void 0 ? void 0 : observerOptions.skip) || !scrollTrackingEnabled
    }));
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleScroll = ()=>{
        const windowHeight = window.innerHeight;
        const fullHeight = document.documentElement.scrollHeight;
        const currentPosition = window.scrollY;
        scrollPercentage.current = Math.round(currentPosition / (fullHeight - windowHeight) * 100);
    };
    (0, $1oC0p.useEffect)(()=>{
        if (inView && !hasFunctionBeenCalled.current && section) {
            handleScroll();
            const scrollTrackAnalyticsPayload = {
                eventType: "ui",
                action: "scrolledTo",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: (0, $6ogO3._)({
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId
                }, additionalAttributes)
            };
            const dwellTimeTrackAnalyticsPayload = {
                eventType: "ui",
                action: "dwellTimeTracked",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: (0, $6ogO3._)({
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId
                }, additionalAttributes)
            };
            if (analyticsClient) {
                createAnalyticsEvent((0, $6ogO3._)({}, scrollTrackAnalyticsPayload)).fire();
                hasFunctionBeenCalled.current = true;
            }
            if (dwellTimeEnabled) {
                const activityEvents = [
                    "mousemove",
                    "keydown",
                    "scroll",
                    "touchstart"
                ];
                let intervalId = undefined;
                let activityTimeout = undefined;
                let active = true;
                // stop tracking after 1 minute of inactivity
                const setActive = ()=>{
                    active = true;
                    clearTimeout(activityTimeout);
                    activityTimeout = setTimeout(()=>{
                        active = false;
                    }, 60000);
                };
                activityEvents.forEach((evt)=>{
                    window.addEventListener(evt, setActive);
                });
                // emmit every 5 seconds if the user is active
                intervalId = setInterval(()=>{
                    if (active) {
                        handleScroll();
                        createAnalyticsEvent((0, $6ogO3._)({}, dwellTimeTrackAnalyticsPayload)).fire();
                    } else {
                        clearInterval(intervalId);
                        clearTimeout(activityTimeout);
                        activityEvents.forEach((evt)=>{
                            window.removeEventListener(evt, setActive);
                        });
                    }
                }, 5000);
            }
        }
    }, [
        additionalAttributes,
        analyticsClient,
        createAnalyticsEvent,
        dwellTimeEnabled,
        hasFunctionBeenCalled,
        inView,
        index,
        pageId,
        section
    ]);
    return {
        ref: ref,
        inView: inView,
        entry: entry
    };
};
const $0fbf1a9bc3d0315b$export$1725757b7947b890 = ({ section: section, index: index, observerOptions: observerOptions, children: children, as: RootElement = "div" })=>{
    const { ref: ref } = $0fbf1a9bc3d0315b$export$17700584f55fbc70(section, {
        index: index,
        observerOptions: observerOptions
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)(RootElement, {
        ref: ref,
        children: children
    });
};
function $0fbf1a9bc3d0315b$export$391633ede08dabb1(section, InnerComponent, options) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)($0fbf1a9bc3d0315b$export$1725757b7947b890, (0, $dPABA._)((0, $6ogO3._)({
            section: section
        }, options), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)(InnerComponent, (0, $6ogO3._)({}, props))
        }));
    };
}

});



parcelRegister("9dCmO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b6316d01b13082f$var$_react = $6b6316d01b13082f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6b6316d01b13082f$var$_baseNew = $6b6316d01b13082f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $6b6316d01b13082f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b6316d01b13082f$var$CommentIcon = (props)=>/*#__PURE__*/ $6b6316d01b13082f$var$_react.default.createElement($6b6316d01b13082f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$6b6316d01b13082f$var$CommentIcon.displayName = 'CommentIcon';
var $6b6316d01b13082f$var$_default = module.exports.default = $6b6316d01b13082f$var$CommentIcon;

});

parcelRegister("ppCkT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84a07eff465bcaaea8db49f0fc7877da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04c634faffce0aa7$var$_react = $04c634faffce0aa7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $04c634faffce0aa7$var$_baseNew = $04c634faffce0aa7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $04c634faffce0aa7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Department".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for departments, reporting lines, or other tree chart representations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04c634faffce0aa7$var$DepartmentIcon = (props)=>/*#__PURE__*/ $04c634faffce0aa7$var$_react.default.createElement($04c634faffce0aa7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.5.75A.75.75 0 0 1 6.25 0h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-1v2.25h3.125c.76 0 1.375.616 1.375 1.375V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.75h-7.5V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.625c0-.76.616-1.375 1.375-1.375H7.25V5h-1a.75.75 0 0 1-.75-.75zM7 1.5v2h2v-2zm-4.5 11v2h2v-2zm9 0v2h2v-2z" clip-rule="evenodd"/>`
    }, props));
$04c634faffce0aa7$var$DepartmentIcon.displayName = 'DepartmentIcon';
var $04c634faffce0aa7$var$_default = module.exports.default = $04c634faffce0aa7$var$DepartmentIcon;

});

parcelRegister("b2tob", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8b466fb905db85ecf24180397d24c4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8096adab141a7275$var$_react = $8096adab141a7275$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8096adab141a7275$var$_baseNew = $8096adab141a7275$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $8096adab141a7275$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8096adab141a7275$var$EditIcon = (props)=>/*#__PURE__*/ $8096adab141a7275$var$_react.default.createElement($8096adab141a7275$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$8096adab141a7275$var$EditIcon.displayName = 'EditIcon';
var $8096adab141a7275$var$_default = module.exports.default = $8096adab141a7275$var$EditIcon;

});

parcelRegister("6zF1U", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5f93e34be6622a1cb8208e9984b09a45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c95d69c59142f9b$var$_react = $4c95d69c59142f9b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4c95d69c59142f9b$var$_baseNew = $4c95d69c59142f9b$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $4c95d69c59142f9b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4c95d69c59142f9b$var$LightbulbIcon = (props)=>/*#__PURE__*/ $4c95d69c59142f9b$var$_react.default.createElement($4c95d69c59142f9b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$4c95d69c59142f9b$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $4c95d69c59142f9b$var$_default = module.exports.default = $4c95d69c59142f9b$var$LightbulbIcon;

});

parcelRegister("gjva1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::045b0e6f318b6cb40cf896c360eca820>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be06978ded12aba7$var$_react = $be06978ded12aba7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $be06978ded12aba7$var$_baseNew = $be06978ded12aba7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $be06978ded12aba7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be06978ded12aba7$var$TeamsIcon = (props)=>/*#__PURE__*/ $be06978ded12aba7$var$_react.default.createElement($be06978ded12aba7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$be06978ded12aba7$var$TeamsIcon.displayName = 'TeamsIcon';
var $be06978ded12aba7$var$_default = module.exports.default = $be06978ded12aba7$var$TeamsIcon;

});

parcelRegister("5alrx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7831691c1245bdf104acebfc690a968c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c2e8512528ccc45$var$_react = $3c2e8512528ccc45$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3c2e8512528ccc45$var$_baseNew = $3c2e8512528ccc45$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $3c2e8512528ccc45$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3c2e8512528ccc45$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $3c2e8512528ccc45$var$_react.default.createElement($3c2e8512528ccc45$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$3c2e8512528ccc45$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $3c2e8512528ccc45$var$_default = module.exports.default = $3c2e8512528ccc45$var$EyeOpenIcon;

});

parcelRegister("eMDDH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac344be6bebfa432$var$_react = $ac344be6bebfa432$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ac344be6bebfa432$var$_baseNew = $ac344be6bebfa432$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $ac344be6bebfa432$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ac344be6bebfa432$var$FeedbackIcon = (props)=>/*#__PURE__*/ $ac344be6bebfa432$var$_react.default.createElement($ac344be6bebfa432$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$ac344be6bebfa432$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $ac344be6bebfa432$var$_default = module.exports.default = $ac344be6bebfa432$var$FeedbackIcon;

});

parcelRegister("cB1fn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92b9e8622fafa0ab$var$_react = $92b9e8622fafa0ab$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $92b9e8622fafa0ab$var$_baseNew = $92b9e8622fafa0ab$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $92b9e8622fafa0ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92b9e8622fafa0ab$var$FileIcon = (props)=>/*#__PURE__*/ $92b9e8622fafa0ab$var$_react.default.createElement($92b9e8622fafa0ab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$92b9e8622fafa0ab$var$FileIcon.displayName = 'FileIcon';
var $92b9e8622fafa0ab$var$_default = module.exports.default = $92b9e8622fafa0ab$var$FileIcon;

});

parcelRegister("6ED9p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c464a7d95484e897372db9f1fff872cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0140140442510c7f$var$_react = $0140140442510c7f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $0140140442510c7f$var$_baseNew = $0140140442510c7f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $0140140442510c7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0140140442510c7f$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $0140140442510c7f$var$_react.default.createElement($0140140442510c7f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$0140140442510c7f$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $0140140442510c7f$var$_default = module.exports.default = $0140140442510c7f$var$ListBulletedIcon;

});

parcelRegister("dTWad", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e0a5e9b0b4b1b954a0d2b89a777fbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1ed8782c3681aeb$var$_react = $a1ed8782c3681aeb$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a1ed8782c3681aeb$var$_baseNew = $a1ed8782c3681aeb$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $a1ed8782c3681aeb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1ed8782c3681aeb$var$RoadmapIcon = (props)=>/*#__PURE__*/ $a1ed8782c3681aeb$var$_react.default.createElement($a1ed8782c3681aeb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$a1ed8782c3681aeb$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $a1ed8782c3681aeb$var$_default = module.exports.default = $a1ed8782c3681aeb$var$RoadmapIcon;

});

parcelRegister("HMZ3r", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("ftgEA")).ContentPlatformImage; });

var $ftgEA = parcelRequire("ftgEA");

});
parcelRegister("ftgEA", function(module, exports) {
$parcel$export(module.exports, "ContentPlatformImage", function () { return $93bafa18ccb06246$export$f8e4eb6f7b9af79c; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $imIsw = parcelRequire("imIsw");
const $93bafa18ccb06246$export$f8e4eb6f7b9af79c = (_param)=>{
    var { contentType: contentType, src: src, alt: alt, baseWidth: baseWidth } = _param, rest = (0, $aPnCa._)(_param, [
        "contentType",
        "src",
        "alt",
        "baseWidth"
    ]);
    const queryPairs = [];
    let srcSet = [];
    if (contentType === "image/png") {
        queryPairs.push("fm=webp");
        if (baseWidth) {
            srcSet = (0, $imIsw.getSrcSet)(src, baseWidth, queryPairs, "w");
            queryPairs.push(`w=${baseWidth}`);
        }
    }
    const queryString = queryPairs.length > 0 ? `?${queryPairs.join("&")}` : "";
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $7VQPk.jsx)("img", (0, $dPABA._)((0, $6ogO3._)({
        loading: "lazy"
    }, rest), {
        src: `${src}${queryString}`,
        srcSet: srcSet.length > 0 ? srcSet.join(",") : undefined,
        alt: alt
    })));
};

});


parcelRegister("6VSBC", function(module, exports) {
$parcel$export(module.exports, "EnterprisePageProductNav", function () { return $3872cd7d84b2ef7a$export$e36ad2737327f9c; });
$parcel$export(module.exports, "default", function () { return $3872cd7d84b2ef7a$export$2e2bcd8739ae039; });
/* enterprise-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");
const $3872cd7d84b2ef7a$var$logoWrapperStyles = null;
const $3872cd7d84b2ef7a$var$EnterpriseLogo = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1q51v77o _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Logo), {
            brand: "enterprise",
            type: "logo",
            appearance: "brand"
        })
    });
const $3872cd7d84b2ef7a$export$e36ad2737327f9c = ({ isActive: isActive })=>{
    const intl = (0, $8e22h.default)();
    const ctaButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.navbar.cta",
        defaultMessage: "Contact sales"
    });
    const mobileCtaButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.navbar.mobile.cta",
        defaultMessage: "Contact sales"
    });
    const links = [
        {
            globalLinksKey: "overview",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.overview",
                defaultMessage: "Overview"
            }),
            hasSubnav: false,
            isActive: isActive == "overview",
            productKey: "enterprise",
            href: (0, $kooLp.useLocalizedHref)("/enterprise")
        },
        {
            globalLinksKey: "success",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.success",
                defaultMessage: "Success"
            }),
            hasSubnav: false,
            isActive: isActive == "success",
            productKey: "enterprise",
            href: (0, $kooLp.useLocalizedHref)("/enterprise/success")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            isActive: isActive == "resources",
            productKey: "enterprise",
            href: (0, $kooLp.useLocalizedHref)("/enterprise/resources")
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-product-navigation",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
            productLogoUrl: (0, $kooLp.useLocalizedHref)("/enterprise"),
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($3872cd7d84b2ef7a$var$EnterpriseLogo, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "EnterpriseLandingPage.label",
                defaultMessage: "Enterprise"
            }),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($3872cd7d84b2ef7a$var$EnterpriseLogo, {}),
            productPageNavLinks: links,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-enterprise",
                    mobileLinksProps: links
                }
            ],
            navigationTrynowCtaText: ctaButtonText,
            navigationTrynowCtaUrl: (0, $kooLp.useLocalizedHref)("/enterprise/contact?formType=product-features"),
            mobileCtaText: mobileCtaButtonText,
            mobileCtaUrl: (0, $kooLp.useLocalizedHref)("/enterprise/contact?formType=product-features")
        })
    });
};
var $3872cd7d84b2ef7a$export$2e2bcd8739ae039 = $3872cd7d84b2ef7a$export$e36ad2737327f9c;

});

parcelRegister("9Cyyz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $701277dc6e7898a3$var$_react = $701277dc6e7898a3$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $701277dc6e7898a3$var$_baseNew = $701277dc6e7898a3$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $701277dc6e7898a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $701277dc6e7898a3$var$AutomationIcon = (props)=>/*#__PURE__*/ $701277dc6e7898a3$var$_react.default.createElement($701277dc6e7898a3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$701277dc6e7898a3$var$AutomationIcon.displayName = 'AutomationIcon';
var $701277dc6e7898a3$var$_default = module.exports.default = $701277dc6e7898a3$var$AutomationIcon;

});

parcelRegister("f2RFx", function(module, exports) {
$parcel$export(module.exports, "StrategyCollectionNavbar", function () { return $75474cece0afe122$export$8f1cb1d63697797a; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $l2QYX = parcelRequire("l2QYX");

var $lVpxp = parcelRequire("lVpxp");

var $bNHK1 = parcelRequire("bNHK1");
const $75474cece0afe122$export$8f1cb1d63697797a = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.GlobalNav), {
        productKey: "home",
        compoundNav: (0, $dPABA._)((0, $6ogO3._)({}, (0, $lVpxp.CollectionsCompoundSubNavProps)()), {
            ctaUrl: (0, $bNHK1.CTA_URL_PATH)
        })
    });
};

});
parcelRegister("lVpxp", function(module, exports) {
$parcel$export(module.exports, "CollectionsCompoundSubNavProps", function () { return $41aac9f09a5b294b$export$7390cb3961621991; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $kooLp = parcelRequire("kooLp");

var $cR2Ov = parcelRequire("cR2Ov");

var $5yuBp = parcelRequire("5yuBp");
const $41aac9f09a5b294b$export$7390cb3961621991 = ()=>{
    const intl = (0, $8e22h.default)();
    const teamworkOverviewHref = (0, $kooLp.useLocalizedHref)("/collections/teamwork");
    const teamworkFeaturesHref = (0, $kooLp.useLocalizedHref)("/collections/teamwork/features");
    const teamworkEnterpriseHref = (0, $kooLp.useLocalizedHref)("/collections/teamwork/enterprise");
    const teamworkPricingHref = (0, $kooLp.useLocalizedHref)("/collections/teamwork/pricing");
    const teamworkResourcesHref = (0, $kooLp.useLocalizedHref)("/collections/teamwork/resources");
    const strategyOverviewHref = (0, $kooLp.useLocalizedHref)("/collections/strategy");
    const strategyDemoCenterHref = (0, $kooLp.useLocalizedHref)("/collections/strategy/demo-center");
    const strategyPricingHref = (0, $kooLp.useLocalizedHref)("/collections/strategy/pricing");
    const serviceOverviewHref = (0, $kooLp.useLocalizedHref)("/collections/service");
    const servicePricingHref = (0, $kooLp.useLocalizedHref)("/collections/service/pricing");
    const softwareHref = (0, $kooLp.useLocalizedHref)("/collections/software");
    const collectionsHref = (0, $kooLp.useLocalizedHref)("/collections");
    // todo: GWP-8380 support collections subnav dropdown menu in mobile
    // 1024 == `media.below.md`, which is the mobile-display threshold
    // specified in services/wac-web/src/patterns/global-nav/src/nav-product-page.tsx
    const isMobile = (0, $5yuBp.useIsMobile)(1024);
    const hasSubnav = !isMobile;
    const props = {
        optionalClassName: "collections-nav",
        compoundSubNavTitle: "Collections",
        compoundSubNavTitleHref: collectionsHref,
        compoundSubNavLinksProps: [
            {
                globalLinksKey: "teamwork",
                linkText: "Teamwork",
                href: teamworkOverviewHref,
                hasSubnav: hasSubnav,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.overview",
                                        defaultMessage: "Overview"
                                    }),
                                    href: teamworkOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.features",
                                        defaultMessage: "Features"
                                    }),
                                    href: teamworkFeaturesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.enterprise",
                                        defaultMessage: "Enterprise"
                                    }),
                                    href: teamworkEnterpriseHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.pricing",
                                        defaultMessage: "Pricing"
                                    }),
                                    href: teamworkPricingHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.resources",
                                        defaultMessage: "Resources"
                                    }),
                                    href: teamworkResourcesHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "strategy",
                linkText: "Strategy",
                href: strategyOverviewHref,
                hasSubnav: hasSubnav,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.overview",
                                        defaultMessage: "Overview"
                                    }),
                                    href: strategyOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.demoCenter",
                                        defaultMessage: "Demo Center"
                                    }),
                                    href: strategyDemoCenterHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.pricing",
                                        defaultMessage: "Pricing"
                                    }),
                                    href: strategyPricingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "service",
                linkText: "Service",
                href: serviceOverviewHref,
                hasSubnav: hasSubnav,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.overview",
                                        defaultMessage: "Overview"
                                    }),
                                    href: serviceOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.pricing",
                                        defaultMessage: "Pricing"
                                    }),
                                    href: servicePricingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "software",
                linkText: "Software",
                hasSubnav: false,
                href: softwareHref
            }
        ],
        isShowCta: false,
        ctaButtonText: intl.formatMessage({
            id: "collectionsCompoundSubNav.cta.contactSales",
            defaultMessage: "Contact Sales"
        }),
        ctaButtonVariant: "primary",
        ctaUrl: "#contact"
    };
    return props;
};

});

parcelRegister("bNHK1", function(module, exports) {
$parcel$export(module.exports, "CTA_URL_PATH", function () { return $05e82cdc2e6c5ddf$export$d5587a12d9eea1dc; });
const $05e82cdc2e6c5ddf$export$d5587a12d9eea1dc = "/collections/strategy#contact";

});


parcelRegister("hGxEi", function(module, exports) {

var $iCQu6 = parcelRequire("iCQu6");

var $24uwp = parcelRequire("24uwp");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $ce0075e69d454d18$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $ce0075e69d454d18$var$rsComboMarksRange = '\\u0300-\\u036f', $ce0075e69d454d18$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $ce0075e69d454d18$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $ce0075e69d454d18$var$rsComboRange = $ce0075e69d454d18$var$rsComboMarksRange + $ce0075e69d454d18$var$reComboHalfMarksRange + $ce0075e69d454d18$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $ce0075e69d454d18$var$rsCombo = '[' + $ce0075e69d454d18$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $ce0075e69d454d18$var$reComboMark = RegExp($ce0075e69d454d18$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $ce0075e69d454d18$var$deburr(string) {
    string = $24uwp(string);
    return string && string.replace($ce0075e69d454d18$var$reLatin, $iCQu6).replace($ce0075e69d454d18$var$reComboMark, '');
}
module.exports = $ce0075e69d454d18$var$deburr;

});
parcelRegister("iCQu6", function(module, exports) {

var $6V9cT = parcelRequire("6V9cT");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $037fd0776303ae37$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $037fd0776303ae37$var$deburrLetter = $6V9cT($037fd0776303ae37$var$deburredLetters);
module.exports = $037fd0776303ae37$var$deburrLetter;

});
parcelRegister("6V9cT", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $509f35426b22b824$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $509f35426b22b824$var$basePropertyOf;

});



parcelRegister("lXgpb", function(module, exports) {

var $gHIMV = parcelRequire("gHIMV");

var $dNNx2 = parcelRequire("dNNx2");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $ffbbd5682208087f$var$camelCase = $dNNx2(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $gHIMV(word) : word);
});
module.exports = $ffbbd5682208087f$var$camelCase;

});
parcelRegister("dNNx2", function(module, exports) {

var $5r99q = parcelRequire("5r99q");

var $hGxEi = parcelRequire("hGxEi");

var $cGaAm = parcelRequire("cGaAm");
/** Used to compose unicode capture groups. */ var $a0c645f3644bc61c$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $a0c645f3644bc61c$var$reApos = RegExp($a0c645f3644bc61c$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $a0c645f3644bc61c$var$createCompounder(callback) {
    return function(string) {
        return $5r99q($cGaAm($hGxEi(string).replace($a0c645f3644bc61c$var$reApos, '')), callback, '');
    };
}
module.exports = $a0c645f3644bc61c$var$createCompounder;

});
parcelRegister("5r99q", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $3f56928ff1fa1456$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $3f56928ff1fa1456$var$arrayReduce;

});

parcelRegister("cGaAm", function(module, exports) {

var $agIzJ = parcelRequire("agIzJ");

var $2fyoH = parcelRequire("2fyoH");

var $24uwp = parcelRequire("24uwp");

var $51QbK = parcelRequire("51QbK");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $93b19e4fcd969484$var$words(string, pattern, guard) {
    string = $24uwp(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $2fyoH(string) ? $51QbK(string) : $agIzJ(string);
    return string.match(pattern) || [];
}
module.exports = $93b19e4fcd969484$var$words;

});
parcelRegister("agIzJ", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $779df9bff564b02d$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $779df9bff564b02d$var$asciiWords(string) {
    return string.match($779df9bff564b02d$var$reAsciiWord) || [];
}
module.exports = $779df9bff564b02d$var$asciiWords;

});

parcelRegister("2fyoH", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $1a37aa184b5f841b$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $1a37aa184b5f841b$var$hasUnicodeWord(string) {
    return $1a37aa184b5f841b$var$reHasUnicodeWord.test(string);
}
module.exports = $1a37aa184b5f841b$var$hasUnicodeWord;

});

parcelRegister("51QbK", function(module, exports) {
/** Used to compose unicode character classes. */ var $3a9587500dbb7d28$var$rsAstralRange = '\\ud800-\\udfff', $3a9587500dbb7d28$var$rsComboMarksRange = '\\u0300-\\u036f', $3a9587500dbb7d28$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $3a9587500dbb7d28$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $3a9587500dbb7d28$var$rsComboRange = $3a9587500dbb7d28$var$rsComboMarksRange + $3a9587500dbb7d28$var$reComboHalfMarksRange + $3a9587500dbb7d28$var$rsComboSymbolsRange, $3a9587500dbb7d28$var$rsDingbatRange = '\\u2700-\\u27bf', $3a9587500dbb7d28$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $3a9587500dbb7d28$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $3a9587500dbb7d28$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $3a9587500dbb7d28$var$rsPunctuationRange = '\\u2000-\\u206f', $3a9587500dbb7d28$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $3a9587500dbb7d28$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $3a9587500dbb7d28$var$rsVarRange = '\\ufe0e\\ufe0f', $3a9587500dbb7d28$var$rsBreakRange = $3a9587500dbb7d28$var$rsMathOpRange + $3a9587500dbb7d28$var$rsNonCharRange + $3a9587500dbb7d28$var$rsPunctuationRange + $3a9587500dbb7d28$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $3a9587500dbb7d28$var$rsApos = "['\u2019]", $3a9587500dbb7d28$var$rsBreak = '[' + $3a9587500dbb7d28$var$rsBreakRange + ']', $3a9587500dbb7d28$var$rsCombo = '[' + $3a9587500dbb7d28$var$rsComboRange + ']', $3a9587500dbb7d28$var$rsDigits = '\\d+', $3a9587500dbb7d28$var$rsDingbat = '[' + $3a9587500dbb7d28$var$rsDingbatRange + ']', $3a9587500dbb7d28$var$rsLower = '[' + $3a9587500dbb7d28$var$rsLowerRange + ']', $3a9587500dbb7d28$var$rsMisc = '[^' + $3a9587500dbb7d28$var$rsAstralRange + $3a9587500dbb7d28$var$rsBreakRange + $3a9587500dbb7d28$var$rsDigits + $3a9587500dbb7d28$var$rsDingbatRange + $3a9587500dbb7d28$var$rsLowerRange + $3a9587500dbb7d28$var$rsUpperRange + ']', $3a9587500dbb7d28$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $3a9587500dbb7d28$var$rsModifier = '(?:' + $3a9587500dbb7d28$var$rsCombo + '|' + $3a9587500dbb7d28$var$rsFitz + ')', $3a9587500dbb7d28$var$rsNonAstral = '[^' + $3a9587500dbb7d28$var$rsAstralRange + ']', $3a9587500dbb7d28$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $3a9587500dbb7d28$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $3a9587500dbb7d28$var$rsUpper = '[' + $3a9587500dbb7d28$var$rsUpperRange + ']', $3a9587500dbb7d28$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $3a9587500dbb7d28$var$rsMiscLower = '(?:' + $3a9587500dbb7d28$var$rsLower + '|' + $3a9587500dbb7d28$var$rsMisc + ')', $3a9587500dbb7d28$var$rsMiscUpper = '(?:' + $3a9587500dbb7d28$var$rsUpper + '|' + $3a9587500dbb7d28$var$rsMisc + ')', $3a9587500dbb7d28$var$rsOptContrLower = '(?:' + $3a9587500dbb7d28$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $3a9587500dbb7d28$var$rsOptContrUpper = '(?:' + $3a9587500dbb7d28$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $3a9587500dbb7d28$var$reOptMod = $3a9587500dbb7d28$var$rsModifier + '?', $3a9587500dbb7d28$var$rsOptVar = '[' + $3a9587500dbb7d28$var$rsVarRange + ']?', $3a9587500dbb7d28$var$rsOptJoin = '(?:' + $3a9587500dbb7d28$var$rsZWJ + '(?:' + [
    $3a9587500dbb7d28$var$rsNonAstral,
    $3a9587500dbb7d28$var$rsRegional,
    $3a9587500dbb7d28$var$rsSurrPair
].join('|') + ')' + $3a9587500dbb7d28$var$rsOptVar + $3a9587500dbb7d28$var$reOptMod + ')*', $3a9587500dbb7d28$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $3a9587500dbb7d28$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $3a9587500dbb7d28$var$rsSeq = $3a9587500dbb7d28$var$rsOptVar + $3a9587500dbb7d28$var$reOptMod + $3a9587500dbb7d28$var$rsOptJoin, $3a9587500dbb7d28$var$rsEmoji = '(?:' + [
    $3a9587500dbb7d28$var$rsDingbat,
    $3a9587500dbb7d28$var$rsRegional,
    $3a9587500dbb7d28$var$rsSurrPair
].join('|') + ')' + $3a9587500dbb7d28$var$rsSeq;
/** Used to match complex or compound words. */ var $3a9587500dbb7d28$var$reUnicodeWord = RegExp([
    $3a9587500dbb7d28$var$rsUpper + '?' + $3a9587500dbb7d28$var$rsLower + '+' + $3a9587500dbb7d28$var$rsOptContrLower + '(?=' + [
        $3a9587500dbb7d28$var$rsBreak,
        $3a9587500dbb7d28$var$rsUpper,
        '$'
    ].join('|') + ')',
    $3a9587500dbb7d28$var$rsMiscUpper + '+' + $3a9587500dbb7d28$var$rsOptContrUpper + '(?=' + [
        $3a9587500dbb7d28$var$rsBreak,
        $3a9587500dbb7d28$var$rsUpper + $3a9587500dbb7d28$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $3a9587500dbb7d28$var$rsUpper + '?' + $3a9587500dbb7d28$var$rsMiscLower + '+' + $3a9587500dbb7d28$var$rsOptContrLower,
    $3a9587500dbb7d28$var$rsUpper + '+' + $3a9587500dbb7d28$var$rsOptContrUpper,
    $3a9587500dbb7d28$var$rsOrdUpper,
    $3a9587500dbb7d28$var$rsOrdLower,
    $3a9587500dbb7d28$var$rsDigits,
    $3a9587500dbb7d28$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $3a9587500dbb7d28$var$unicodeWords(string) {
    return string.match($3a9587500dbb7d28$var$reUnicodeWord) || [];
}
module.exports = $3a9587500dbb7d28$var$unicodeWords;

});




parcelRegister("9b72g", function(module, exports) {
$parcel$export(module.exports, "BitbucketNav", function () { return (parcelRequire("atyps")).BitbucketNav; });
$parcel$export(module.exports, "WhyBitbucketSubnav", function () { return (parcelRequire("fv5hW")).WhyBitbucketSubnav; });
parcelRequire("atyps");
parcelRequire("fv5hW");

});
parcelRegister("atyps", function(module, exports) {
$parcel$export(module.exports, "BitbucketNav", function () { return $46b40aa87e150696$export$374e7235418bdbdb; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $33ot9 = parcelRequire("33ot9");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $32ng3 = parcelRequire("32ng3");
parcelRequire("9b72g");
var $fv5hW = parcelRequire("fv5hW");
const $46b40aa87e150696$var$BitbucketLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "bitbucket",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $33ot9.BitbucketLogo), {
        appearance: "brand"
    });
};
const $46b40aa87e150696$export$374e7235418bdbdb = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=bitbucket&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $5kPBa.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).BITBUCKET,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const dataCenterHref = (0, $kooLp.useLocalizedHref)("/software/bitbucket/enterprise/data-center");
    const pricingHref = (0, $kooLp.useLocalizedHref)("/software/bitbucket/pricing");
    const links = [
        {
            globalLinksKey: "whyBitbucket",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.whyBitbucket",
                defaultMessage: "Why Bitbucket"
            }),
            productKey: "bitbucket",
            hasSubnav: true,
            dropdownType: "why-bitbucket"
        },
        {
            globalLinksKey: "self-hosted",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.selfhosted",
                defaultMessage: "Self-Hosted"
            }),
            hasSubnav: false,
            productKey: "bitbucket",
            href: dataCenterHref
        },
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.pricing",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            productKey: "bitbucket",
            href: pricingHref
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-BitbucketNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
            productKey: "bitbucket",
            productLogoUrl: "/software/bitbucket",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($46b40aa87e150696$var$BitbucketLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.bitbucket-logo",
                defaultMessage: "Bitbucket logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($46b40aa87e150696$var$BitbucketLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "whyBitbucket",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.whyBitbucket",
                        defaultMessage: "Why Bitbucket"
                    }),
                    containerStyles: {
                        width: "fit-content",
                        margin: 0
                    },
                    hasSubnav: true,
                    content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fv5hW.WhyBitbucketSubnav), {
                        productKey: "bitbucket"
                    })
                },
                {
                    globalLinksKey: "self-hosted",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.selfhosted",
                        defaultMessage: "Self-Hosted"
                    }),
                    hasSubnav: false,
                    productKey: "bitbucket",
                    href: dataCenterHref
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "bitbucket",
                    href: pricingHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-bitbucket",
                    mobileLinksProps: links
                }
            ]
        })
    });
};

});
parcelRegister("33ot9", function(module, exports) {
$parcel$export(module.exports, "BitbucketLogo", function () { return $2394a1fec8c53679$export$bd40525f5333524b; });
/* eslint-disable max-len */ 
var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $2TpZZ = parcelRequire("2TpZZ");

var $cTVn3 = parcelRequire("cTVn3");
var $2394a1fec8c53679$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2TpZZ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 158 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill=".concat(colors.iconColor, " d=\"m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95\"/>\n        <path fill=").concat(colors.textColor, " d=\"M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z\"/>\n      </svg>");
};
var $2394a1fec8c53679$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $2394a1fec8c53679$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("fv5hW", function(module, exports) {
$parcel$export(module.exports, "WhyBitbucketSubnav", function () { return $e0ef30a4e223c9fa$export$7b115720fff1fb0d; });
/* why-bitbucket-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $8nFt2 = parcelRequire("8nFt2");

var $jgdMW = parcelRequire("jgdMW");

var $dfBhn = parcelRequire("dfBhn");

var $9KOR3 = parcelRequire("9KOR3");
function $e0ef30a4e223c9fa$var$useWhyBitbucketLinks() {
    return {
        features: {
            id: "solution",
            title: (0, $fnHPc.defineMessage)({
                id: "bitbucketnav.subnav.whybitbucket.links.solution",
                defaultMessage: "Solution"
            }),
            items: [
                {
                    id: "ci-cd",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.work-management",
                        defaultMessage: "CI/CD"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/bitbucket/features/pipelines")
                },
                {
                    id: "cloud-security",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.cloud-security",
                        defaultMessage: "Cloud Security"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/bitbucket/features/cloud-security")
                },
                {
                    id: "dev-sec-ops",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.dev-sec-ops",
                        defaultMessage: "DevSecOps"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/bitbucket/features/devsecops")
                },
                {
                    id: "code-review",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.it-service-management",
                        defaultMessage: "Code Review"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/bitbucket/features/code-review")
                },
                {
                    id: "jira-integrations",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.agile-devops",
                        defaultMessage: "Jira Integrations"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/jira/bitbucket-integration")
                }
            ]
        },
        plans: {
            id: "plans",
            title: (0, $fnHPc.defineMessage)({
                id: "bitbucketnav.subnav.whybitbucket.links.plans",
                defaultMessage: "Plans"
            }),
            items: [
                {
                    id: "bitbucket-cloud-premium",
                    text: (0, $fnHPc.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.bitbucket-cloud-premium",
                        defaultMessage: "Bitbucket Cloud Premium"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/bitbucket/premium")
                }
            ]
        }
    };
}
const $e0ef30a4e223c9fa$export$7b115720fff1fb0d = ({ productKey: productKey = "bitbucket" })=>{
    const intl = (0, $8e22h.default)();
    const bitbucketLinks = $e0ef30a4e223c9fa$var$useWhyBitbucketLinks();
    const linkColumns = Object.values(bitbucketLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: "up",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhk1rga"
                    ]),
                    style: {
                        "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgdMW.RowGrid), {
                        numCols: 2,
                        columnGap: "var(--ds-space-500, 40px)",
                        paddingBlock: "var(--ds-space-500, 40px)",
                        paddingInline: "var(--ds-space-500, 40px)",
                        children: linkColumns.map((column)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dfBhn.LinkColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1p1dangw _syaz1hlo _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                                        ]),
                                        style: {
                                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                        },
                                        children: intl.formatMessage(column.title)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _2z0510ma"
                                        ]),
                                        children: column.items.map((link)=>{
                                            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_bpsp1nn1 _19tboxwj _43ds1hlo _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1hlo _oavv1ep1 _oxk41ep1 _1e0c1txw _4cvrh9n0"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                                    "--_1pjqntz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue800"))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                                    type: "anchor",
                                                    href: link.href,
                                                    text: intl.formatMessage(link.text),
                                                    ariaLabel: intl.formatMessage(link.text),
                                                    dataEventProps: {
                                                        "data-event": "clicked",
                                                        "data-event-component": "linkButton",
                                                        "data-event-container": "globalNavSubnav",
                                                        "data-product-key": productKey
                                                    }
                                                })
                                            }, link.id);
                                        })
                                    })
                                ]
                            }, column.id);
                        })
                    })
                })
            })
        })
    });
};

});


parcelRegister("lgKym", function(module, exports) {
$parcel$export(module.exports, "CompassNav", function () { return $73340f47439b5afe$export$78e93448314ae49; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $jwykx = parcelRequire("jwykx");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $32ng3 = parcelRequire("32ng3");
const $73340f47439b5afe$var$CompassLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "compass",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jwykx.CompassLogo), {
        appearance: "brand"
    });
};
const $73340f47439b5afe$export$78e93448314ae49 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=compass&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $5kPBa.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).COMPASS,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const pricingHref = (0, $kooLp.useLocalizedHref)("/software/compass/pricing");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-CompassNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
            productLogoUrl: "/software/compass",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($73340f47439b5afe$var$CompassLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "CompassPageTemplate.navbar.compass-logo",
                defaultMessage: "Compass logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "CompassPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "CompassPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($73340f47439b5afe$var$CompassLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "features",
                    linkText: intl.formatMessage({
                        id: "CompassPageTemplate.navbar.features",
                        defaultMessage: "Features"
                    }),
                    hasSubnav: false,
                    productKey: "compass",
                    href: (0, $kooLp.useLocalizedHref)("/software/compass/features")
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "CompassPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "compass",
                    href: pricingHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-compass",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "features",
                            linkText: intl.formatMessage({
                                id: "CompassPageTemplate.navbar.features",
                                defaultMessage: "Features"
                            }),
                            hasSubnav: false,
                            productKey: "compass",
                            href: (0, $kooLp.useLocalizedHref)("/software/compass/features")
                        },
                        {
                            globalLinksKey: "pricing",
                            linkText: intl.formatMessage({
                                id: "CompassPageTemplate.navbar.pricing",
                                defaultMessage: "Pricing"
                            }),
                            hasSubnav: false,
                            productKey: "compass",
                            href: pricingHref
                        }
                    ]
                }
            ]
        })
    });
};

});
parcelRegister("jwykx", function(module, exports) {
$parcel$export(module.exports, "CompassLogo", function () { return $e36ba2bb4efdeb40$export$eb7d748e4f9c9676; });
/* eslint-disable max-len */ 
var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $2TpZZ = parcelRequire("2TpZZ");

var $cTVn3 = parcelRequire("cTVn3");
var $e36ba2bb4efdeb40$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2TpZZ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 155 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill=".concat(colors.iconColor, " d=\"M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z\"/>\n    <path fill=\"").concat(colors.textColor, "\" d=\"M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n  </svg>");
};
var $e36ba2bb4efdeb40$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $e36ba2bb4efdeb40$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("g2lQR", function(module, exports) {
$parcel$export(module.exports, "GuardNav", function () { return $97dc5fc3d3238142$export$941339143e9f5522; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $fz5gy = parcelRequire("fz5gy");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $32ng3 = parcelRequire("32ng3");
const $97dc5fc3d3238142$var$GuardLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "guard",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fz5gy.GuardLogo), {
        appearance: "brand"
    });
};
const $97dc5fc3d3238142$export$941339143e9f5522 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = "https://admin.atlassian.com/atlassian-guard";
    const { openCrossFlow: openCrossFlow } = (0, $5kPBa.useCrossFlowFrontendTouchpoint)({
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const capabilitiesHref = (0, $kooLp.useLocalizedHref)("/software/guard/capabilities");
    const pricingHref = (0, $kooLp.useLocalizedHref)("/software/guard/pricing");
    const guideHref = (0, $kooLp.useLocalizedHref)("/software/guard/guide#getting-started");
    const demoHref = (0, $kooLp.useLocalizedHref)("/software/guard/demo");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-GuardNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
            productLogoUrl: "/software/guard",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($97dc5fc3d3238142$var$GuardLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "GuardPageTemplate.navbar.guard-logo",
                defaultMessage: "Guard logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "GuardPageTemplate.navbar.tryitfree",
                defaultMessage: "Try it free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "GuardPageTemplate.navbar.tryitfree",
                defaultMessage: "Try it free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($97dc5fc3d3238142$var$GuardLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "capabilities",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.capabilities",
                        defaultMessage: "Capabilities"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: capabilitiesHref
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: pricingHref
                },
                {
                    globalLinksKey: "guide",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.guide",
                        defaultMessage: "Guide"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: guideHref
                },
                {
                    globalLinksKey: "demo",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.demo",
                        defaultMessage: "Demo"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: demoHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-guard",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "capabilities",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.capabilities",
                                defaultMessage: "Capabilities"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: capabilitiesHref
                        },
                        {
                            globalLinksKey: "pricing",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.pricing",
                                defaultMessage: "Pricing"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: pricingHref
                        },
                        {
                            globalLinksKey: "guide",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.guide",
                                defaultMessage: "Guide"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: guideHref
                        },
                        {
                            globalLinksKey: "demo",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.demo",
                                defaultMessage: "Demo"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: demoHref
                        }
                    ]
                }
            ]
        })
    });
};

});

parcelRegister("aYwTu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a060b684c4f472c9$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $5kPBa = parcelRequire("5kPBa");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $32ng3 = parcelRequire("32ng3");
const $a060b684c4f472c9$var$JpdLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV2), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    });
};
const $a060b684c4f472c9$var$JiraProductDiscoveryNavV2 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery");
    const { openCrossFlow: openCrossFlow } = (0, $5kPBa.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const links = [
        {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                // this id can be renamed once the above has been fixed as well
                id: "jiraproductdiscovery.navbar.product-features",
                defaultMessage: "Features"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $kooLp.useLocalizedHref)("/software/jira/product-discovery/features")
        },
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                // this id should be renamed, but for Team'24 hotfix we need to keep existing mapping
                id: "jiraproductdiscovery.navbar.features",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $kooLp.useLocalizedHref)("/software/jira/product-discovery/pricing")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "jiraproductdiscovery.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $kooLp.useLocalizedHref)("/software/jira/product-discovery/resources")
        }
    ];
    // TODO: this duplicates the value from the v1 product nav
    // this was to use an accurate existing translation for a Team'24 hot fix
    const ctaText = intl.formatMessage({
        id: "productNavBar.get-it-free-button",
        defaultMessage: "Get it free"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
        productLogoUrl: (0, $kooLp.useLocalizedHref)("/software/jira/product-discovery"),
        productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($a060b684c4f472c9$var$JpdLogo, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: "wacJiraProductDiscoveryNavigation.logo-label",
            defaultMessage: "Jira Product Discovery logo"
        }),
        mobileCtaText: ctaText,
        mobileCtaUrl: signupLink,
        mobileCtaOnClick: openCrossFlow,
        mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($a060b684c4f472c9$var$JpdLogo, {}),
        navigationTrynowCtaText: ctaText,
        navigationTrynowCtaUrl: signupLink,
        navigationTrynowCtaOnClick: openCrossFlow,
        productPageNavLinks: links,
        mobileLinksSections: [
            {
                mobileLinkKey: "mobile-jira-product-discovery",
                mobileLinksProps: links
            }
        ]
    });
};
$a060b684c4f472c9$var$JiraProductDiscoveryNavV2.displayName = "JiraProductDiscoveryNavV2";
var $a060b684c4f472c9$export$2e2bcd8739ae039 = $a060b684c4f472c9$var$JiraProductDiscoveryNavV2;

});

parcelRegister("kH7QU", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionLogo", function () { return $f10dea1b0839dfd3$export$6e87ce8d41eda665; });
/* eslint-disable max-len */ 
var $1oC0p = parcelRequire("1oC0p");

var $l8aSY = parcelRequire("l8aSY");

var $eggzj = parcelRequire("eggzj");

var $2TpZZ = parcelRequire("2TpZZ");

var $cTVn3 = parcelRequire("cTVn3");
var $f10dea1b0839dfd3$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2TpZZ.getColorsForLoom)(appearance, colorMode);
    return "<svg\n\t\tfill=\"none\"\n\t\theight=\"32\"\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\tfocusable=\"false\"\n\t\taria-hidden=\"true\"\n\t\tviewBox=\"0 0 88 32\"\n\t>\n\t\t<path\n\t\t\td=\"M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058\"\n\t\t\tfill=\"".concat(colors.iconColor, "\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z\"\n\t\t\tfill=\"").concat(colors.textColor, "\"\n\t\t/>\n\t</svg>");
};
var $f10dea1b0839dfd3$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom Attribution' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eggzj.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eggzj.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eggzj.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $l8aSY.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cTVn3.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $f10dea1b0839dfd3$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("3wzIU", function(module, exports) {
$parcel$export(module.exports, "RovoNav", function () { return $d94e8e579fb0c00d$export$f7b51e35c95f667c; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $3o1l4 = parcelRequire("3o1l4");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $l2QYX = parcelRequire("l2QYX");

var $cR2Ov = parcelRequire("cR2Ov");

var $ea4mV = parcelRequire("ea4mV");

var $32ng3 = parcelRequire("32ng3");

var $3riD8 = parcelRequire("3riD8");
const $d94e8e579fb0c00d$export$f7b51e35c95f667c = ()=>{
    var _userSegments_UserSegmentTypes_OWNED_PRODUCTS;
    const intl = (0, $8e22h.default)();
    const navLinks = [
        {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.features",
                defaultMessage: "Features"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $kooLp.useLocalizedHref)("/software/rovo/features")
        },
        {
            globalLinksKey: "connectors",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.connectors",
                defaultMessage: "Connectors"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $kooLp.useLocalizedHref)("/software/rovo/connectors")
        },
        {
            globalLinksKey: "use-cases",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.use-cases",
                defaultMessage: "Use cases"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $kooLp.useLocalizedHref)("/software/rovo/use-cases")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: true,
            productKey: "rovo",
            containerPosition: "relative",
            content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                orientation: "column",
                contentSections: [
                    {
                        links: [
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.ai-adoption-resources",
                                    defaultMessage: "AI adoption resources"
                                }),
                                href: (0, $kooLp.useLocalizedHref)("http://community.atlassian.com/learning/hub/rovo")
                            },
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.admin-onboarding",
                                    defaultMessage: "Admin onboarding"
                                }),
                                href: (0, $kooLp.useLocalizedHref)("/software/rovo/guides/admin-guide")
                            },
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.end-user-onboarding",
                                    defaultMessage: "End-user onboarding"
                                }),
                                href: (0, $kooLp.useLocalizedHref)("/software/rovo/guides/end-user-guide")
                            }
                        ]
                    }
                ]
            })
        },
        {
            globalLinksKey: "licensing",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.licensing",
                defaultMessage: "Licensing"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $kooLp.useLocalizedHref)("/licensing/rovo")
        }
    ];
    const { isUserLoggedIn: isUserLoggedIn, requestInProgress: requestInProgress } = (0, $3riD8.useLoggedInUser)();
    const isRovoCtasEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp8011RovoProductTour);
    const gwp8979RovoOnWacButtonEG = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).gwp8979RovoChatOnWac);
    const gwp8979RovoOnWacButtonFG = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp8979RovoOnWacButton);
    const { data: userSegments } = (0, $3o1l4.useUserSegments)();
    const isRovoInPlanList = userSegments === null || userSegments === void 0 ? void 0 : (_userSegments_UserSegmentTypes_OWNED_PRODUCTS = userSegments[(0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS]) === null || _userSegments_UserSegmentTypes_OWNED_PRODUCTS === void 0 ? void 0 : _userSegments_UserSegmentTypes_OWNED_PRODUCTS.includes("rovo.ondemand");
    const defaultCTAUrl = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=teamwork-collection&primaryCollectionProduct=rovo.ondemand&edition=premium");
    const isUserLoggedInAndCtasEnabledAndInPlan = isUserLoggedIn && isRovoCtasEnabled && isRovoInPlanList;
    const isRovoEnabled = isUserLoggedInAndCtasEnabledAndInPlan || gwp8979RovoOnWacButtonEG.type === "enrolled" && gwp8979RovoOnWacButtonEG.value;
    const ctaText = isRovoEnabled ? intl.formatMessage({
        id: "RovoPageTemplate.navbar.cta.try-rovo",
        defaultMessage: "Try Rovo"
    }) : isRovoCtasEnabled ? intl.formatMessage({
        id: "RovoPageTemplate.navbar.cta.get-rovo",
        defaultMessage: "Get Rovo"
    }) : undefined;
    const tryNowCTAUrl = isUserLoggedInAndCtasEnabledAndInPlan ? "https://home.atlassian.com/chat" : isRovoCtasEnabled ? defaultCTAUrl : undefined;
    const isShowTryNowLink = !requestInProgress && tryNowCTAUrl && ctaText ? true : false;
    const shouldShowCTAButtonVariant = gwp8979RovoOnWacButtonEG.type === "enrolled" && gwp8979RovoOnWacButtonEG.value && gwp8979RovoOnWacButtonFG;
    const buttonVariant = shouldShowCTAButtonVariant ? "secondary" : "primary";
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "RovoNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.ProductPageSubNav), {
            productLogoUrl: "/software/rovo",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
                brand: "rovo",
                type: "logo",
                appearance: "brand"
            }),
            productLogoAriaLabel: intl.formatMessage({
                id: "RovoPageTemplate.navbar.rovo-logo",
                defaultMessage: "Rovo logo"
            }),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
                brand: "rovo",
                type: "logo",
                appearance: "brand"
            }),
            isShowTryNowLink: isShowTryNowLink,
            isIncludeMobileCTA: isShowTryNowLink,
            navigationTrynowCtaText: isShowTryNowLink ? ctaText : undefined,
            navigationTrynowCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            navigationTrynowCtaButtonVariant: buttonVariant,
            mobileCtaText: isShowTryNowLink ? ctaText : undefined,
            mobileCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            mobileCtaButtonVariant: buttonVariant,
            productPageNavLinks: navLinks,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-rovo",
                    mobileLinksProps: navLinks
                }
            ]
        })
    });
};

});

parcelRegister("9qukn", function(module, exports) {
$parcel$export(module.exports, "DropdownSelector", function () { return (parcelRequire("grkXZ")).DropdownSelector; });

var $grkXZ = parcelRequire("grkXZ");

});
parcelRegister("grkXZ", function(module, exports) {
$parcel$export(module.exports, "DropdownSelector", function () { return $7df351058cf48215$export$67ffdcf8cfce0fd; });
/* dropdown-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $kKAAc = parcelRequire("kKAAc");
const $7df351058cf48215$var$dropdownSelectorContainerStyle = null;
const $7df351058cf48215$var$labelStyle = null;
const $7df351058cf48215$var$labelStyleSignup = null;
const $7df351058cf48215$export$67ffdcf8cfce0fd = ({ options: options, name: name, id: id, testId: testId, label: label, onChangeHandler: onChangeHandler, defaultValue: defaultValue, cssOverrides: cssOverrides, className: className })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $1oC0p.useState)(false);
    const elementID = id ? id : `${name}-dropdown`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c116y _2lx21bp4 _1bsb1osq",
            className
        ]),
        children: [
            (cssOverrides === null || cssOverrides === void 0 ? void 0 : cssOverrides.labelStyle) === "signup" && /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                htmlFor: elementID,
                className: (0, $2jatx.default)([
                    "_syazvwuj _vwz41gnr _6rth1b66 _y3gn1e5h _k48pbfng _1wybdlk8"
                ]),
                children: label
            }),
            !(cssOverrides === null || cssOverrides === void 0 ? void 0 : cssOverrides.labelStyle) && /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                htmlFor: elementID,
                className: (0, $2jatx.default)([
                    "_syazvwuj _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                ]),
                children: label
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: "select-dropdown-container",
                "data-testid": testId ? testId : elementID,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kKAAc.default), {
                    defaultValue: defaultValue || {
                        label: "Select...",
                        value: ""
                    },
                    options: options,
                    unstyled: true,
                    inputId: elementID,
                    onChange: (selectedOption)=>{
                        onChangeHandler === null || onChangeHandler === void 0 ? void 0 : onChangeHandler((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) || "");
                    },
                    onMenuOpen: ()=>setIsMenuOpen(true),
                    onMenuClose: ()=>setIsMenuOpen(false),
                    styles: {
                        // @ts-ignore
                        container: (provided)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                appearance: "none",
                                flexDirection: "row",
                                fontSize: "1rem",
                                lineHeight: "1.2",
                                textAlign: "left"
                            }), (cssOverrides || {}).container),
                        // @ts-ignore
                        singleValue: (provided)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                marginLeft: "var(--ds-space-025, 2px)",
                                marginRight: "var(--ds-space-025, 2px)"
                            }), (cssOverrides || {}).singleValue),
                        // @ts-ignore
                        placeholder: (provided)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                marginLeft: "var(--ds-space-025, 2px)",
                                marginRight: "var(--ds-space-025, 2px)"
                            }), (cssOverrides || {}).placeholder),
                        // @ts-ignore
                        valueContainer: (provided)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                paddingLeft: "var(--ds-space-075, 6px)",
                                paddingRight: "var(--ds-space-075, 6px)"
                            }), (cssOverrides || {}).valueContainer),
                        // @ts-ignore
                        menu: (provided)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                marginTop: "var(--ds-space-050, 4px)",
                                // eslint-disable-next-line local/ensure-wac-token-usage
                                boxShadow: "0px 3px 5px 0px #091E4233",
                                // eslint-disable-next-line local/ensure-wac-token-usage
                                background: "#ffffff",
                                padding: 0,
                                borderRadius: "var(--ds-space-050, 4px)"
                            }), (cssOverrides || {}).menu),
                        // @ts-ignore
                        control: (provided, state)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                "cursor": "pointer",
                                "backgroundColor": isMenuOpen ? "#253858" : "#FAFBFC",
                                "color": isMenuOpen ? "#ffffff" : "#172B4D",
                                "height": "2.65rem",
                                "border": state.isFocused ? `2px solid #4C9AFF` : `2px solid #dfe1e6`,
                                "borderRadius": "var(--ds-space-050, 4px)",
                                "&:hover": {
                                    background: isMenuOpen ? undefined : "#F4F5F7"
                                }
                            }), (cssOverrides || {}).control),
                        // @ts-ignore
                        dropdownIndicator: (provided, state)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                transition: "all .2s ease",
                                transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : undefined
                            }), (cssOverrides || {}).dropdownIndicator),
                        // @ts-ignore
                        indicatorsContainer: (provided)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                paddingTop: "var(--ds-space-075, 6px)",
                                paddingBottom: "var(--ds-space-075, 6px)",
                                paddingLeft: "var(--ds-space-025, 2px)",
                                paddingRight: "var(--ds-space-075, 6px)"
                            }), (cssOverrides || {}).indicatorsContainer),
                        // @ts-ignore
                        option: (provided, state)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                "cursor": "pointer",
                                "padding": `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`,
                                "whiteSpace": "pre-wrap",
                                "overflowWrap": "break-word",
                                "backgroundColor": state.isSelected ? "#B2D4FF" : state.isFocused ? "#EBECF0" : "#FAFBFC",
                                "color": state.isSelected ? "#0065FF" : "#172B4D",
                                "&:hover": {
                                    background: state.isSelected ? "#B2D4FF" : "#EBECF0"
                                },
                                "&:active": {
                                    // eslint-disable-next-line local/ensure-wac-token-usage
                                    background: "#DFE1E5"
                                }
                            }), (cssOverrides || {}).option),
                        // @ts-ignore
                        input: (provided)=>(0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, provided), {
                                color: "transparent"
                            }), (cssOverrides || {}).input)
                    }
                })
            })
        ]
    });
};

});


parcelRegister("7Xpzl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d43a7428702b82788297fb999fe29f0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cb1e08dc9ec04f5$var$_react = $5cb1e08dc9ec04f5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5cb1e08dc9ec04f5$var$_baseNew = $5cb1e08dc9ec04f5$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $5cb1e08dc9ec04f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cb1e08dc9ec04f5$var$InformationIcon = (props)=>/*#__PURE__*/ $5cb1e08dc9ec04f5$var$_react.default.createElement($5cb1e08dc9ec04f5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$5cb1e08dc9ec04f5$var$InformationIcon.displayName = 'InformationIcon';
var $5cb1e08dc9ec04f5$var$_default = module.exports.default = $5cb1e08dc9ec04f5$var$InformationIcon;

});

parcelRegister("iMdbU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2b2be59784c9b52b8b3b5b23f53d5b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dab6f123f69f6bcc$var$_react = $dab6f123f69f6bcc$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $dab6f123f69f6bcc$var$_baseNew = $dab6f123f69f6bcc$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $dab6f123f69f6bcc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dab6f123f69f6bcc$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $dab6f123f69f6bcc$var$_react.default.createElement($dab6f123f69f6bcc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m14.877 2.03-4 4a.75.75 0 0 1-1.051.01L8.98 8.262l1.04-1.08 1.316 1.267 3.48-3.48zM3.75 10.5a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.52a3.75 3.75 0 0 1 3.75 3.75V15h-1.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$dab6f123f69f6bcc$var$PersonAddedIcon.displayName = 'PersonAddedIcon';
var $dab6f123f69f6bcc$var$_default = module.exports.default = $dab6f123f69f6bcc$var$PersonAddedIcon;

});

parcelRegister("7pQ29", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b34e6857b52d4ec156a688609aa0810c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56633b0430bc4d64$var$_react = $56633b0430bc4d64$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $56633b0430bc4d64$var$_baseNew = $56633b0430bc4d64$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $56633b0430bc4d64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Phone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: call us, phone number input.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56633b0430bc4d64$var$PhoneIcon = (props)=>/*#__PURE__*/ $56633b0430bc4d64$var$_react.default.createElement($56633b0430bc4d64$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h3.5a.75.75 0 0 1 .721.544l.821 2.874a1.75 1.75 0 0 1-.562 1.825L4.29 7.86c.975 1.55 2.3 2.875 3.85 3.85l1.617-1.94a1.75 1.75 0 0 1 1.825-.562l2.874.82a.75.75 0 0 1 .544.722v3.5a.75.75 0 0 1-.75.75c-2.266 0-4.422-.61-6.309-1.664a13.77 13.77 0 0 1-5.277-5.277A12.9 12.9 0 0 1 1 1.75m8.484 10.69c1.25.578 2.606.94 4.016 1.035v-2.16l-2.33-.665a.25.25 0 0 0-.26.08zM3.56 6.516 5.27 5.09a.25.25 0 0 0 .08-.261L4.684 2.5H2.525A11.4 11.4 0 0 0 3.56 6.516" clip-rule="evenodd"/>`
    }, props));
$56633b0430bc4d64$var$PhoneIcon.displayName = 'PhoneIcon';
var $56633b0430bc4d64$var$_default = module.exports.default = $56633b0430bc4d64$var$PhoneIcon;

});

parcelRegister("kHMU7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c615014b011664b243a37531e093f861>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f12dc2233694369e$var$_react = $f12dc2233694369e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f12dc2233694369e$var$_baseNew = $f12dc2233694369e$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f12dc2233694369e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f12dc2233694369e$var$WarningIcon = (props)=>/*#__PURE__*/ $f12dc2233694369e$var$_react.default.createElement($f12dc2233694369e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$f12dc2233694369e$var$WarningIcon.displayName = 'WarningIcon';
var $f12dc2233694369e$var$_default = module.exports.default = $f12dc2233694369e$var$WarningIcon;

});

parcelRegister("gNuc8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4a862ad906af43648c20a01ac989d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3a8a4fb00075491$var$_react = $c3a8a4fb00075491$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c3a8a4fb00075491$var$_baseNew = $c3a8a4fb00075491$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $c3a8a4fb00075491$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrend".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3a8a4fb00075491$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $c3a8a4fb00075491$var$_react.default.createElement($c3a8a4fb00075491$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h1.5v7.94l3.22-3.22a.75.75 0 0 1 1.06 0L8.5 7.44l3.94-3.94H10V2h4.25a.75.75 0 0 1 .75.75V7h-1.5V4.56L9.03 9.03a.75.75 0 0 1-1.06 0L6.25 7.31 2.5 11.06V13a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$c3a8a4fb00075491$var$ChartTrendIcon.displayName = 'ChartTrendIcon';
var $c3a8a4fb00075491$var$_default = module.exports.default = $c3a8a4fb00075491$var$ChartTrendIcon;

});

parcelRegister("l6HGO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f5dc0c5d851b1603$var$_react = $f5dc0c5d851b1603$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f5dc0c5d851b1603$var$_baseNew = $f5dc0c5d851b1603$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f5dc0c5d851b1603$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f5dc0c5d851b1603$var$StarStarredIcon = (props)=>/*#__PURE__*/ $f5dc0c5d851b1603$var$_react.default.createElement($f5dc0c5d851b1603$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$f5dc0c5d851b1603$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $f5dc0c5d851b1603$var$_default = module.exports.default = $f5dc0c5d851b1603$var$StarStarredIcon;

});


var $67UrT = parcelRequire("67UrT");

var $3NQOU = parcelRequire("3NQOU");
(0, $3NQOU.init)((0, $67UrT.UniformEntryPage));


//# sourceMappingURL=uniform-entry-page.ac2364ba.js.map
